export default {
    "generalErrorMessage": {
        "fieldIsRequired": "ફીલ્ડ જરૂરી છે",
        "field_required": "આ ફીલ્ડ જરૂરી છે",
        "something_went_wrong": "ક્યાંક ખોટું થયું"
    },
    "authErrorMessage": {
        "emailError": "ઈમેલ ફીલ્ડ માન્ય ઈમેલ હોવી જોઈએ",
        "passwordValid": "પાસવર્ડ ફીલ્ડમાં ઓછામાં ઓછા 8 અક્ષરો હોવા જોઈએ",
        "validPassRegex": "પાસવર્ડમાં ઓછામાં ઓછા 8 અક્ષરો લાંબા હોવા જોઈએ, અને તેમાં ઓછામાં ઓછા 1 અક્ષર, 1 મોટા અક્ષર, 1 સંખ્યાત્મક અને 1 વિશેષ અક્ષર હોવું જોઈએ",
        "confirmPasswordValid": "કન્ફર્મ પાસવર્ડ પુષ્ટિ મેળ ખાતી નથી",
        "validCharactersfirst": "પ્રથમ નામ ફીલ્ડમાં માત્ર આલ્ફાબેટિક અક્ષરો તેમજ જગ્યા હોઈ શકે છે",
        "validCharacterslast": "છેલ્લું નામ ફીલ્ડમાં માત્ર આલ્ફાબેટિક અક્ષરો તેમજ જગ્યા હોઈ શકે છે",
        "minMust": "ઓછામાં ઓછા 3 અક્ષરો હોવા જોઈએ",
        "must_be_a_valid_email": "માન્ય ઈમેલ હોવી જોઈએ",
        "currentPassword": "વર્તમાન પાસવર્ડ ઓછામાં ઓછા 8 અક્ષર લાંબા હોવા જોઈએ, અને ઓછામાં ઓછા 1 મૂળાક્ષર, 1 અપરકેસ, 1 આંકડાકીય અને 1 વિશેષ અક્ષર હોવા જોઈએ",
        "newPassword": "નવા પાસવર્ડ ઓછામાં ઓછા 8 અક્ષરના હોવા જોઈએ અને ઓછામાં ઓછા 1 મૂળાક્ષર, 1 અપરકેસ, 1 આંકડાકીય અને 1 વિશેષ અક્ષર હોવા જોઈએ",
        "currentPasswordValid": "વર્તમાન પાસવર્ડ ફીલ્ડ ઓછામાં ઓછા 8 અક્ષરોનો હોવો જોઈએ",
        "newPasswordValid": "નવા પાસવર્ડ ફીલ્ડમાં ઓછામાં ઓછા 8 અક્ષરો હોવા જોઈએ",
        "please_wait_before_resending_email": "તમારા ઈમેઈલની તપાસ કરો. જો તમને તે પ્રાપ્ત ન થાય તો, 1 મિનિટ પછી તમે પુનઃપ્રમાણિત ઈમેઈલ મોકલી શકો છો."
    },
    "companyErrorMessage": {
        "phoneNumberValid": "ફોન નંબર ફીલ્ડમાં ઓછામાં ઓછા 10 અક્ષરો હોવા જોઈએ",
        "Something_went_wrong_Please_contact_to_admin": "કંઈક ખોટું થયું. કૃપા કરીને એડમિનનો સંપર્ક કરો"
    },
    "errorPage": {
        "project_name": "પ્રોજેક્ટ નામ",
        "project_key": "પ્રોજેક્ટ કી",
        "project_category": "પ્રોજેક્ટ કેટેગરી",
        "team_name": "ટીમ નામ",
        "The": "તે",
        "field_must_be_a_valid": "ફીલ્ડ માન્ય હોવી જોઈએ",
        "email": "ઈમેલ",
        "password": "પાસવર્ડ",
        "first_name": "પ્રથમ નામ",
        "last_name": "છેલ્લું નામ",
        "company_name": "કંપની નામ",
        "file_extension": "ફાઇલ એક્સટેન્શન",
        "milestone_status": "માઇલસ્ટોન સ્થિતિ",
        "name": "નામ",
        "phone_number": "ફોન નંબર",
        "field_must_be_at_least": "ફીલ્ડ ઓછામાં ઓછા હોવી જોઈએ",
        "number": "નંબર",
        "characters": "અક્ષરો",
        "digits": "અંક",
        "priority_name": "પ્રાથમિકતા નામ",
        "firstName": "પ્રથમ નામ",
        "lastName": "છેલ્લું નામ",
        "phoneNumber": "ફોન નંબર",
        "amount": "રકમ",
        "phone": "ફોન",
        "country": "દેશ",
        "state": "રાજ્ય",
        "city": "શહેર",
        "templatename": "ટેમ્પલેટ નામ",
        "description": "વર્ણન",
        "Template_name_is_required": "ટેમ્પલેટ નામ જરૂરી છે",
        "This_template_name_is_required.": "આ ટેમ્પલેટ નામ જરૂરી છે.",
        "status": "સ્થિતિ",
        "zipcode": "ઝિપકોડ",
        "address2": "સરનામું 2",
        "address1": "સરનામું 1",
        "The_confirm_password_field_is_required": "કન્ફર્મ પાસવર્ડ ફીલ્ડ જરૂરી છે",
        "The_confirm_password_confirmation_does_not_match": "કન્ફર્મ પાસવર્ડ પુષ્ટિ મેળ ખાતી નથી",
        "terms_and_condition": "શરતો અને શરતો",
        "category_name": "કેટેગરી નામ",
        "channel_name": "ચેનલ નામ",
        "amount_per_hours": "પ્રતિ કલાક રકમ",
        "refundamount": "પરતફેર રકમ",
        "please_select_template": "કૃપા કરીને ટેમ્પલેટ પસંદ કરો",
        "template_name_already_exists": "ટેમ્પલેટ નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "select_a_date": "તારીખ પસંદ કરો",
        "must_be_less_than": "ઓછું હોવું જોઈએ",
        "project_duedate": "પ્રોજેક્ટ નમૂનાઓ તારીખ",
        "project_lead_assignee": "પ્રોજેક્ટ લીડ અસાઇનિ",
        "current_password": "વર્તમાન પાસવર્ડ",
        "new_password": "નવો પાસવર્ડ",
        "confirm_password": "પાસવર્ડની પુષ્ટિ કરો",
        "This_template_name_is_already_exists": "આ ટેમ્પલેટ નામ પહેલેથી જ અસ્તિત્વમાં છે.",
        "card_name": "કાર્ડનું નામ",
        "topic": "વિષય",
        "target_audience": "લક્ષિત પ્રેક્ષકો",
        "keywords": "મુખ્ય શબ્દો",
        "content_purpose": "સામગ્રીનો હેતુ",
        "product/service": "ઉત્પાદન/સેવા",
        "campaign_goals": "ઝુંબેશના લક્ષ્યો",
        "value_proposition": "મૂલ્ય પ્રસ્તાવ",
        "objectives": "ઉદ્દેશ્યો",
        "key_message": "મુખ્ય સંદેશ",
        "problem": "સમસ્યા",
        "context": "સંદર્ભ",
        "constraints": "મર્યાદાઓ",
        "main_keyword": "મુખ્ય કીવર્ડ",
        "secondary_keywords": "ગૌણ કીવર્ડ",
        "content_goal": "સામગ્રીનો લક્ષ્ય",
        "keyword_list": "કીવર્ડ યાદી",
        "questions": "પ્રશ્નો",
        "product_description": "ઉત્પાદન વર્ણન",
        "feedback_data": "પ્રતિસાદ ડેટા",
        "survey_questions": "સર્વેના પ્રશ્નો",
        "project": "પ્રોજેક્ટ",
        "progress_made": "થયેલી પ્રગતિ",
        "next_steps": "આગળના પગલાં",
        "key_features": "મુખ્ય લક્ષણો",
        "client_type": "ક્લાયંટ પ્રકાર",
        "challenges": "પડકારો",
        "results": "પરિણામો",
        "event_type": "ઇવેન્ટ પ્રકાર",
        "cta": "કાર્ય આહ્વાન",
        "campaign_objectives": "ઝુંબેશના ઉદ્દેશ્યો",
        "survey_objectives": "સર્વેના ઉદ્દેશ્યો",
        "column_one_name": "પહેલા કૉલમનું નામ",
        "column_two_name": "બીજા કૉલમનું નામ",
        "column_one_data": "પહેલા કૉલમનો ડેટા",
        "column_two_data": "બીજા કૉલમનો ડેટા",
        "customer_name": "ગ્રાહકનું નામ",
        "email_purpose": "ઇમેલનો હેતુ",
        "talking_points": "ચર્ચાના મુદ્દાઓ",
        "product_name": "ઉત્પાદનનું નામ",
        "about_the_product": "ઉત્પાદન વિશે",
        "core_problem_it_solves": "તે જે મુખ્ય સમસ્યા હલ કરે છે",
        "what_makes_it_different": "તેને શું અલગ બનાવે છે",
        "the_product_is": "ઉત્પાદન છે",
        "core_differentiators": "મુખ્ય ભેદકો",
        "product/service_benefits": "ઉત્પાદન/સેવાના ફાયદા",
        "call_notes": "કૉલ નોંધો",
        "call_transcript": "કૉલ ટ્રાન્સક્રિપ્ટ",
        "target_company": "લક્ષિત કંપની",
        "use_case": "ઉપયોગ કેસ",
        "customer_challenges": "ગ્રાહકના પડકારો",
        "territories": "પ્રદેશો",
        "target_industries": "લક્ષિત ઉદ્યોગો",
        "sales_goals": "વેચાણ લક્ષ્યો",
        "sales_strategies": "વેચાણ વ્યૂહરચના",
        "transcript": "ટ્રાન્સક્રિપ્ટ",
        "pain_points": "પીડાના મુદ્દાઓ",
        "company_type": "કંપની પ્રકાર",
        "sales_cycle_stages": "વેચાણ ચક્રના તબક્કાઓ",
        "sales_methodologies": "વેચાણ પદ્ધતિઓ",
        "key_skills": "મુખ્ય કૌશલ્યો",
        "training_formats": "તાલીમ ફોર્મેટ",
        "participants": "સહભાગીઓ",
        "target_industry": "લક્ષિત ઉદ્યોગ",
        "value_statement": "મૂલ્ય નિવેદન",
        "meeting_type": "મીટિંગ પ્રકાર",
        "your_talking_points": "તમારા ચર્ચાના મુદ્દાઓ",
        "goal": "લક્ષ્ય",
        "reasons_for_canceling": "રદ કરવાના કારણો",
        "incentive": "પ્રોત્સાહન",
        "unique_selling_points": "અનન્ય વેચાણ મુદ્દાઓ",
        "desired_format": "ઇચ્છિત ફોર્મેટ",
        "topics": "વિષયો",
        "content": "સામગ્રી",
        "stakeholders": "હિસ્સેદારો",
        "sales_notes": "વેચાણ નોંધો",
        "customer_goals": "ગ્રાહકના લક્ષ્યો",
        "teams_impacted": "પ્રભાવિત ટીમો",
        "requirements": "આવશ્યકતાઓ",
        "goals_met": "પૂર્ણ થયેલા લક્ષ્યો",
        "project_stakeholders": "પ્રોજેક્ટ હિસ્સેદારો",
        "opportunities": "તકો",
        "risks": "જોખમો",
        "customer_message": "ગ્રાહક સંદેશ",
        "date_range": "તારીખ શ્રેણી",
        "project_notes": "પ્રોજેક્ટ નોંધો",
        "project_description": "પ્રોજેક્ટ વર્ણન",
        "name_of_project": "પ્રોજેક્ટનું નામ",
        "date_ranges": "તારીખ શ્રેણીઓ",
        "requestor": "વિનંતીકર્તા",
        "requests": "વિનંતીઓ",
        "reason_for_the_change": "પરિવર્તનનું કારણ",
        "expected_impact_of_the_change": "પરિવર્તનની અપેક્ષિત અસર",
        "project_goals": "પ્રોજેક્ટ લક્ષ્યો",
        "participant_names": "સહભાગીઓના નામો",
        "meeting_time": "મીટિંગનો સમય",
        "timeline": "સમયરેખા",
        "deliverables": "ડિલિવરેબલ્સ",
        "project_goal": "પ્રોજેક્ટ લક્ષ્ય",
        "project_scope": "પ્રોજેક્ટનો અવકાશ",
        "main_task": "મુખ્ય કાર્ય",
        "new_format": "નવું ફોર્મેટ",
        "original_text": "મૂળ ટેક્સ્ટ",
        "stakeholder_titles": "હિસ્સેદારોના પદવીઓ",
        "article_title": "લેખ શીર્ષક",
        "focus_keywords": "ફોકસ કીવર્ડ",
        "title_of_the_blog_text": "બ્લોગ ટેક્સ્ટનું શીર્ષક",
        "blog_topic": "બ્લોગ વિષય",
        "section_title": "વિભાગ શીર્ષક",
        "section_content": "વિભાગ સામગ્રી",
        "section": "વિભાગ",
        "title": "શીર્ષક",
        "title(faq_question)": "શીર્ષક(FAQ પ્રશ્ન)",
        "issue_description": "મુદ્દાનું વર્ણન",
        "code_section": "કોડ વિભાગ",
        "concept": "ખ્યાલ",
        "version": "આવૃત્તિ",
        "changes": "ફેરફારો",
        "job_title": "નોકરી શીર્ષક",
        "your_name": "તમારું નામ",
        "your_skills": "તમારા કૌશલ્યો",
        "math_question": "ગણિતનો પ્રશ્ન",
        "question": "પ્રશ્ન",
        "thesis_topic": "થીસીસ વિષય",
        "text_to_proofread": "તપાસ માટેનો ટેક્સ્ટ",
        "text_to_rephrase": "પુનઃવાક્યાંકન માટેનો ટેક્સ્ટ",
        "text_to_improve": "સુધારા માટેનો ટેક્સ્ટ",
        "job_description": "નોકરીનું વર્ણન",
        "your_title": "તમારું પદ",
        "your_summary": "તમારો સારાંશ",
        "pain": "પીડા",
        "agitation": "આંદોલન",
        "solution": "ઉકેલ",
        "post_content": "પોસ્ટ સામગ્રી",
        "product_or_service": "ઉત્પાદન અથવા સેવા",
        "unique_selling_proposition": "અનન્ય વેચાણ પ્રસ્તાવ",
        "audiences_objectives": "પ્રેક્ષકોના ઉદ્દેશ્યો",
        "email_to_reply_to": "જવાબ આપવા માટે ઇમેલ",
        "sales_teams_roles": "વેચાણ ટીમની ભૂમિકાઓ"
    },
    "Auth": {
        "email": "ઈમેલ",
        "password": "પાસવર્ડ",
        "firstName": "પ્રથમ નામ",
        "lastName": "છેલ્લું નામ",
        "phoneNumber": "ફોન નંબર",
        "login_descriptioon": "તમારા વ્યવસાય સાથે શું ચાલી રહ્યું છે તે જુઓ",
        "login_statement": "તમારા ખાતામાં લોગિન કરો",
        "email_id": "ઈમેલ આઈડી",
        "Password": "પાસવર્ડ",
        "Conform_pass": "કન્ફર્મ પાસવર્ડ",
        "RememberMeL": "મને યાદ રાખો",
        "Remember_password": "પાસવર્ડ યાદ રાખો",
        "Forgot_Password": "પાસવર્ડ ભૂલી ગયા?",
        "loading": "લોડ થઈ રહ્યું છે",
        "loging": "લોગિન",
        "Register": "નોંધણી",
        "NotR": "હજી નોંધણી નથી",
        "createAcc": "ખાતું બનાવો",
        "alredyacc": "પહેલેથી જ એકાઉન્ટ છે?",
        "ResendEmail": "ઈમેલ ફરીથી મોકલો",
        "pleasecheck": "કૃપા કરીને તમારું ઈમેલ તપાસો, જો તમને તે મળ્યું નથી અથવા ખોવાઈ ગયું છે, તો કૃપા કરીને નીચેના બટન પર ક્લિક કરીને ઈમેલ ફરીથી મોકલો.",
        "backlogin": "લોગિન પર પાછા જાઓ",
        "Welcome_Msg": "BRAND_NAME માં આપનું સ્વાગત છે",
        "Welcome_Description": "એકાઉન્ટ બનાવીને વિશિષ્ટ સુવિધાઓનો ઍક્સેસ મેળવો",
        "agree": "હું સંમત છું",
        "tearm": "સેવાની શરતો",
        "and": "અને",
        "Privacy_Policy": "ગોપનીયતા નીતિ",
        "forgatepasswordmsg": "તમારા ખાતા સાથે સંકળાયેલ ઈમેલ દાખલ કરો અને અમે તમારો પાસવર્ડ રીસેટ કરવા માટે સૂચનાઓ સાથે ઈમેલ મોકલશું.",
        "ltitle": "મોટા વિચારો પર કામ કરો, વ્યસ્ત કામ વિના.",
        "time_format": "સમય ફોર્મેટ",
        "timezone": "સમય ઝોન",
        "selectLanguage": "ભાષા પસંદ કરો",
        "check_credentials": "કૃપા કરીને તમારી ઓળખપત્રો તપાસો.",
        "check_smtp_credentials": "કૃપા કરીને તમારી SMTP ઓળખપત્રો તપાસો.",
        "smtp_successfully_verified": "તમારા SMTP ને સફળતાપૂર્વક ચકાસવામાં આવ્યું છે.",
        "verification_code_invalid": "તમારો ચકાસણી કોડ અમાન્ય છે.",
        "verification_code_invalid_check_code": "તમારો ચકાસણી કોડ અમાન્ય છે. કૃપા કરીને તમારો કોડ તપાસો.",
        "verification_mail_sent": "ચકાસણી મેલ સફળતાપૂર્વક મોકલવામાં આવ્યો છે. કૃપા કરીને તમારું ઇનબોક્સ તપાસો.",
        "no_account_found_for_email": "આપેલા ઈમેલ માટે કોઈ ખાતું મળ્યું નથી.",
        "verify_email_and_try_again": "તમારા ઈમેલને ચકાસો અને ફરીથી પ્રયાસ કરો.",
        "confirm_password": "કન્ફર્મ પાસવર્ડ",
        "enter_new_password": "કૃપા કરીને તમારો નવો પાસવર્ડ દાખલ કરો",
        "link_expired_resend_email": "તમારી લિંક સમાપ્ત થઈ ગયો છે.",
        "reset_password": "પાસવર્ડ રીસેટ કરો",
        "resend_verification_email": "કૃપા કરીને ચકાસણી ઈમેલ ફરીથી મોકલવા માટે બટન પર ક્લિક કરો",
        "link_expired": "આ લિંક સમાપ્ત થઈ ગઈ છે",
        "too_many_request": "તમે આપેલા સમયગાળામાં ખૂબ જ વધુ વિનંતીઓ મોકલી છે. કૃપા કરીને રાહ જુવો અને પછી ફરી પ્રયાસ કરો.",
        "previous_wasnot_valid": "તમારું પૂર્વવર્તી પાસવર્ડ માન્ય ન હતું. કૃપા કરીને ચકાસો અને ફરી પ્રયાસ કરો.",
        "password_wasnot_valid": "તમારું નવું પાસવર્ડ માન્ય ન હતું. કૃપા કરીને ફરી પ્રયાસ કરો.",
        "set_new_password": "નવો પાસવર્ડ સેટ કરો",
        "verification_link_expired": "આ ચકાસણી લિંકની સમયમર્યાદા પૂર્ણ થઈ ગઈ છે.",
        "verification_link_expired_message": "કૃપા કરીને તમારા ઇનબોક્સમાં નવીનતમ ચકાસણી ઇમેઇલ તપાસો. જો તમને તે મળ્યું નથી, તો નવી લિંક મેળવવા માટે ફરીથી લોગિન કરવાનો પ્રયાસ કરો.",
        "oAuthGoogleBtnText": "ગૂગલ સાથે ચાલુ રાખો"
    },
    "Home": {
        "unlock": "અનલૉક કરો",
        "lock": "લૉક કરો",
        "dashboardLockSuccess": "ડેશબોર્ડ સફળતાપૂર્વક લૉક કર્યો",
        "dashboardUnlockSuccess": "ડેશબોર્ડ સફળતાપૂર્વક અનલૉક થયો",
        "Home": "હોમ",
        "My_Work": "મારું કામ",
        "Done": "પૂર્ણ",
        "To_Do": "કરવાનું",
        "no_task_found": "કોઈ કાર્ય મળ્યું નથી",
        "Confirm": "પુષ્ટિ કરો",
        "tourclose": "શું તમે ખરેખર આ પ્રવાસ બંધ કરવા માંગો છો? જો તમે પુષ્ટિ કરો છો, તો તમે આ પ્રવાસ માર્ગદર્શિકા ફરીથી ઍક્સેસ કરી શકશો નહીં.",
        "Queue_List": "કતાર યાદી",
        "AddtoQueue": "કતારમાં ઉમેરો",
        "noquelist": "કોઈ કતાર યાદી મળી નથી",
        "Due_Date": "નિયત તારીખ",
        "createQueueTitle": "કતાર બનાવો",
        "Today": "આજે",
        "Calendar": "કૅલેન્ડર",
        "Hide": "છુપાવો",
        "Overdue": "મુદત સમાપ્ત",
        "Next": "આગલું",
        "Unscheduled": "અનિષ્ચિત",
        "task_assign_to_you": "તમને કાર્ય સોંપો",
        "Notification_Request": "સૂચના વિનંતી",
        "no": "ના",
        "yes": "હા",
        "add_task_type": "કાર્ય પ્રકાર ઉમેરો",
        "are_you_sure": "શું તમે બ્રાઉઝર સૂચનાઓ સક્ષમ કરવા માંગો છો?"
    },
    "Header": {
        "Project_Forecasting": "પ્રોજેક્ટ પૂર્વાનુમાન (લલચામા આવે છે)",
        "Resource_Planning": "સ્રોત યોજના (લલચામા આવે છે)",
        "Projects": "પ્રોજેક્ટ્સ",
        "Time_Sheet": "સમય પત્રક",
        "User_Timesheet": "વપરાશકર્તા સમય પત્રક",
        "project_Timesheet": "પ્રોજેક્ટ સમય પત્રક",
        "Workload_Timesheet": "કામનો ભાર સમય પત્રક",
        "Tracker_Timesheet": "ટ્રેકર સમય પત્રક",
        "Time_Forcasting": "સમય અનુમાન",
        "Reports": "અહેવાલો",
        "Milestone_Report": "માઇલસ્ટોન અહેવાલ",
        "Chat": "ચેટ",
        "Notification": "સૂચના",
        "mention": "ઉલ્લેખ",
        "Tours": "પ્રવાસો",
        "Logout": "લોગઆઉટ",
        "Mark_all_as_read": "બધા વાંચેલા તરીકે ચિહ્નિત કરો",
        "Mark_all_as_complete": "બધા પૂર્ણ તરીકે ચિહ્નિત કરો",
        "designation": "હોદ્દો",
        "upgrade_now": "હવે અપગ્રેડ કરો",
        "load_more": "વધુ લોડ કરો",
        "take_tour": "પ્રવાસ લો",
        "task_details": "કાર્ય વિગતો",
        "Comments": "ટિપ્પણીઓ",
        "activity_log": "પ્રવૃત્તિ લોગ",
        "time_log": "સમય લોગ",
        "mentions": "ઉલ્લેખો",
        "Notifications": "સૂચનાઓ",
        "no_data_found": "કોઈ ડેટા મળ્યો નથી",
        "search_results": "શોધ પરિણામો",
        "my_profile": "મારી પ્રોફાઇલ",
        "billing_history": "બિલિંગ ઇતિહાસ",
        "Assignee": "સોંપનાર",
        "Due Date": "નિયત તારીખ",
        "Priority": "પ્રાથમિકતા",
        "Key": "કી",
        "Created Date": "બનાવેલી તારીખ",
        "Created By": "બનાવનાર",
        "advance_search": "અદ્યતન શોધ",
        "for_advance_search": "અદ્યતન શોધ માટે",
        "get_more": "વધુ મેળવો?",
        "to_unlock_activity_view": "પ્રવૃત્તિ દૃશ્ય અનલૉક કરવા માટે",
        "AssigneeUserId": "સોંપનાર",
        "DueDate": "ચુકવણી તારીખ",
        "TaskKey": "કી",
        "Task_Priority": "પ્રાથમિકતા",
        "commentCounts": "ચેટ",
        "created_by": "બનાવ્યું",
        "created_date": "બનાવટી તારીખ",
        "create_project": "પ્રોજેક્ટ બનાવો",
        "Company": "કંપની"
    },
    "ProjectDetails": {
        "select_project_category": "પ્રોજેક્ટ કેટેગરી પસંદ કરો",
        "select_currency": "કરન્સી પસંદ કરો",
        "description": "વર્ણન",
        "details": "વિગતો",
        "status": "સ્થિતિ",
        "assignee": "સોંપનાર",
        "key": "કી",
        "category": "કેટેગરી",
        "source": "સ્રોત",
        "type": "પ્રકાર",
        "billing_period": "બિલિંગ સમયગાળો",
        "currency": "કરન્સી",
        "amount": "રકમ",
        "start_date": "પ્રારંભ તારીખ",
        "end_date": "અંતિમ તારીખ",
        "no_start_date": "કોઈ પ્રારંભ તારીખ નથી",
        "no_end_date": "કોઈ અંતિમ તારીખ નથી",
        "no_due_date": "કોઈ નિયત તારીખ નથી",
        "msg": "પ્રારંભ તારીખને ફેરફાર કરી શકાતી નથી કારણ કે તે પહેલેથી જ",
        "msgbr": "માઇલસ્ટોન શ્રેણી માં છે.",
        "startdatemsg0": "પ્રારંભ તારીખને ફેરફાર કરી શકાતી નથી કારણ કે તે પહેલેથી જ",
        "startdatemsg1": "માઇલસ્ટોન શ્રેણી માં છે.",
        "ok": "બરાબર",
        "lead": "લીડ",
        "browse_by_category": "કેટેગરી દ્વારા બ્રાઉઝ કરો",
        "subtask": "ઉપકાર્ય",
        "details_project_setup": "પ્રોજેક્ટ સેટઅપની વિગતો",
        "avatar": "અવતાર",
        "shared_with": "સાથે શેર કરેલ",
        "no_user_selected": "કોઈ વપરાશકર્તા પસંદ કરેલ નથી",
        "required_view": "જરૂરી દૃશ્યો",
        "set_the_require": "જરૂરી દૃશ્યો સેટ કરો. આ દૃશ્યો આપમેળે પ્રોજેક્ટ્સ, ફોલ્ડર્સ અને લિસ્ટ્સમાં નેવિગેટ કરતી વખતે સક્રિય થશે.",
        "always_required": "હંમેશા જરૂરી",
        "make_default": "ડિફોલ્ટ બનાવો",
        "reporter": "રિપોર્ટર",
        "copy_task_link": "કાર્ય લિંક નકલ કરો",
        "copy_task_key": "કાર્ય કી નકલ કરો",
        "add_que_list": "કતાર યાદીમાં ઉમેરો",
        "remove_que_list": "કતાર યાદીમાંથી દૂર કરો",
        "convert_list": "લિસ્ટમાં રૂપાંતરિત કરો",
        "convert_subtask": "ઉપકાર્યમાં રૂપાંતરિત કરો",
        "merge": "મર્જ કરો",
        "move": "ખસેડો",
        "convert_task": "કાર્યમાં રૂપાંતરિત કરો",
        "no_currency_found": "કોઈ કરન્સી મળી નથી",
        "remove_from_queue_list": "કતાર યાદીમાંથી દૂર કરો",
        "convert": "રૂપાંતરિત કરો",
        "DUPLICATE_AND_OPEN": "નકલ કરો અને ખોલો",
        "MOVE_AND_OPEN": "ખસેડો અને ખોલો",
        "CONVERT_AND_OPEN": "રૂપાંતરિત કરો અને ખોલો",
        "MERGE_AND_OPEN": "મર્જ કરો અને ખોલો"
    },
    "ProjectSlider": {
        "new_project": "નવું પ્રોજેક્ટ",
        "no_archived": "કોઈ આર્કાઇવ ડેટા મળ્યો નથી",
        "you_dont": "તમારા પાસે કોઈ પ્રોજેક્ટ નથી",
        "archived_list": "આર્કાઇવ યાદી",
        "projects": "પ્રોજેક્ટ્સ",
        "project_name": "પ્રોજેક્ટ નામ",
        "folder_name": "ફોલ્ડર નામ",
        "sprint_name": "સ્પ્રિન્ટ નામ",
        "show_archive": "આર્કાઇવ બતાવો",
        "hide_archive": "આર્કાઇવ છુપાવો",
        "try_using_diff": "વિવિધ કીવર્ડ્સનો ઉપયોગ કરવાનો પ્રયાસ કરો",
        "no_project_found": "કોઈ પ્રોજેક્ટ મળ્યો નથી",
        "no_result_found": "કોઈ પરિણામ મળ્યું નથી",
        "select_project_status": "પ્રોજેક્ટ સ્થિતિ પસંદ કરો",
        "no_activity_log_found": "કોઈ પ્રવૃત્તિ લોગ મળ્યો નથી"
    },
    "Projects": {
        "sprint": "સ્પ્રિન્ટ",
        "folder": "ફોલ્ડર",
        "task_view": "કાર્ય દૃશ્ય",
        "default_view": "ડિફોલ્ટ દૃશ્ય",
        "add_view": "દૃશ્ય ઉમેરો",
        "rename": "નામ બદલો",
        "pin": "પિન",
        "edit_code": "કોડ સંપાદિત કરો",
        "copy_link": "લિંક નકલ કરો",
        "delete": "કાઢી નાખો",
        "view": "દૃશ્ય",
        "watchers": "વોચર્સ",
        "files_links": "ફાઇલો અને લિંક્સ",
        "audio_files": "ઓડિયો ફાઇલો",
        "project_permissions": "પ્રોજેક્ટ પરવાનગીઓ",
        "color_avatar": "રંગ અને અવતાર",
        "duplicate": "નકલ",
        "close_project": "પ્રોજેક્ટ બંધ કરો",
        "archive": "આર્કાઇવ",
        "search_in": "માં શોધો",
        "expanded": "વિસ્તૃત",
        "collapsed": "સંકુચિત",
        "me": "હું",
        "status": "સ્થિતિ",
        "priority": "પ્રાથમિકતા",
        "due_date": "નિયત તારીખ",
        "group_by": "દ્વારા જૂથ",
        "subtask": "ઉપકાર્ય",
        "task_name": "કાર્ય નામ",
        "task_key": "કાર્ય કી",
        "everyone": "દરેક",
        "private": "ખાનગી",
        "share_with": "સાથે શેર કરો",
        "create_new_list": "નવી સ્પ્રિન્ટ બનાવો",
        "create_new_folder": "નવું ફોલ્ડર બનાવો",
        "restore": "પુનઃસ્થાપિત કરો",
        "unpin": "પિન દૂર કરો",
        "pinview": "પિન દૃશ્ય",
        "deleteview": "દૃશ્ય કાઢી નાખો",
        "close": "બંધ",
        "cancel": "રદ કરો",
        "tasks": "કાર્યો",
        "save": "સાચવો",
        "create_project": "પ્રોજેક્ટ બનાવો",
        "use_template": "ટેમ્પલેટનો ઉપયોગ કરો",
        "blank_project": "ખાલી પ્રોજેક્ટ",
        "no_category_found": "કોઈ કેટેગરી મળી નથી",
        "template": "ટેમ્પલેટ",
        "save_create": "સાચવો અને બનાવો",
        "save_tamplete": "ટેમ્પલેટ તરીકે સાચવો",
        "previous": "પહેલાનું",
        "new_task": "નવું કાર્ય",
        "add_subtask": "ઉપકાર્ય ઉમેરો",
        "list_of_user": "વપરાશકર્તાની યાદી",
        "list_of_project_status": "પ્રોજેક્ટ સ્થિતિની યાદી",
        "list_of_task_type": "કાર્ય પ્રકારની યાદી",
        "list_of_task_status": "કાર્ય સ્થિતિની યાદી",
        "list_cc": "યાદી cc",
        "category_list": "કેટેગરી યાદી",
        "created_by": "દ્વારા બનાવેલ",
        "tags": "ટૅગ્સ",
        "task_type": "કાર્ય પ્રકાર",
        "workspace": "વર્કસ્પેસ",
        "project_color": "પ્રોજેક્ટ રંગ",
        "search": "શોધો",
        "add_task_need": "તમને જે પ્રકારના કાર્યોની જરૂર છે તે ઉમેરો",
        "what_task_want": "તમે કયો કાર્ય પ્રકાર ઇચ્છો છો",
        "no_sub_tasks_found": "કોઈ ઉપ કાર્યો મળ્યા નથી",
        "all_project": "બધા પ્રોજેક્ટ",
        "closed_project": "બંધ પ્રોજેક્ટ",
        "go_to_project": "પ્રોજેક્ટ પર જાઓ",
        "reopen_project": "પ્રોજેક્ટ ફરીથી ખોલો",
        "required_view": "જરૂરી દૃશ્યો",
        "project_status": "પ્રોજેક્ટ માટેની સ્થિતિ ઉમેરો",
        "what_project": "તમે કઈ પ્રોજેક્ટ સ્થિતિ ઇચ્છો છો",
        "active_status": "સક્રિય સ્થિતિ",
        "done_status": "પૂર્ણ સ્થિતિ",
        "add_status": "સ્થિતિ ઉમેરો",
        "close_status": "સ્થિતિ બંધ કરો",
        "submit": "સબમિટ કરો",
        "Audio_Files": "ઓડિયો ફાઇલો",
        "Files_&_Links": "ફાઇલો અને લિંક્સ",
        "no_audio_file": "કોઈ ઓડિયો ફાઇલો મળ્યા નથી",
        "change_color": "રંગ અને અવતાર બદલો",
        "files": "ફાઇલો",
        "links": "લિંક્સ",
        "about": "વિશે",
        "result": "પરિણામો",
        "seconds": "સેકન્ડ",
        "sort_by": "દ્વારા સૉર્ટ કરો",
        "relevance": "પ્રાસંગિકતા",
        "last_update": "છેલ્લું અપડેટ",
        "last_created": "છેલ્લું બનાવેલ",
        "issue": "મુદ્દો",
        "update": "અપડેટ",
        "date": "તારીખ",
        "time": "સમય",
        "duration": "અવધિ",
        "duplicate_task": "નકલ કાર્ય",
        "projects": "પ્રોજેક્ટ્સ",
        "browse_projects": "પ્રોજેક્ટ્સ બ્રાઉઝ કરો",
        "location": "સ્થાન",
        "add_new": "નવું ઉમેરો",
        "create_compnay": "કંપની બનાવો",
        "company_name": "કંપની નામ",
        "archived_project": "આર્કાઇવ પ્રોજેક્ટ",
        "assignee_teams": "ટીમો",
        "assignee_user": "વપરાશકર્તાઓ",
        "all": "બધા",
        "restore_project": "પ્રોજેક્ટ પુનઃસ્થાપિત કરો",
        "delete_project": "પ્રોજેક્ટ કાઢી નાખો",
        "items_per_page": "પ્રતિ પૃષ્ઠ આઇટમ્સ",
        "Assignee": "સોંપનાર",
        "Project_Created_Date": "પ્રોજેક્ટ બનાવેલી તારીખ",
        "Project_Status": "પ્રોજેક્ટ સ્થિતિ",
        "Project_Type": "પ્રોજેક્ટ પ્રકાર",
        "Comments_Counts": "ટિપ્પણીઓની સંખ્યા",
        "Created_Date": "બનાવેલી તારીખ",
        "Name": "નામ",
        "Running_Time_Tracker": "ચાલતી સમય ટ્રેકર",
        "Assigned_to": "સોંપેલ",
        "Project": "પ્રોજેક્ટ",
        "Currency": "કરન્સી",
        "Milestone_Type": "માઇલસ્ટોન પ્રકાર",
        "Project_Category": "પ્રોજેક્ટ કેટેગરી",
        "Comment_Type": "ટિપ્પણી પ્રકાર",
        "results_in_time": "ફળો માં",
        "create_blank_project": "ખાલી પ્રોજેક્ટ બનાવો",
        "create_project_using_template": "ટેમ્પલેટનો ઉપયોગ કરીને પ્રોજેક્ટ બનાવો",
        "choose_apps": "એપ્લિકેશન્સ પસંદ કરો"
    },
    "Watcher": {
        "ignore": "અવગણો",
        "participating_mentions": "ભાગ લેનાર અને {'@'}mentions",
        "list_of_watcher": "વોચર્સની યાદી",
        "all_activity": "બધી પ્રવૃત્તિ",
        "watchers_list": "વોચર્સ યાદી",
        "owner": "માલિક"
    },
    "ViewList": {
        "List": "યાદી",
        "Board": "બોર્ડ",
        "Project Details": "પ્રોજેક્ટ વિગતો",
        "Comments": "ટિપ્પણીઓ",
        "Calendar": "કૅલેન્ડર",
        "Activity": "પ્રવૃત્તિ",
        "Workload": "કામનો ભાર",
        "Gantt": "ગાન્ટ",
        "Table": "ટેબલ",
        "Timeline": "સમયરેખા",
        "Embed": "એમ્બેડ",
        "Comment": "ટિપ્પણી",
        "to_unlock_list_view": "યાદી દૃશ્ય અનલૉક કરવા માટે",
        "error_message_for_empty": "કૃપા કરીને ઓછામાં ઓછી એક દૃશ્ય પસંદ કરો",
        "set_as_default": "મૂળભૂત તરીકે સુયોજિત કરો",
        "remove_as_default": "મૂળભૂત તરીકે દૂર કરો"
    },
    "Apps": {
        "tags": "ટૅગ્સ",
        "Priority": "પ્રાથમિકતા",
        "TimeEstimates": "સમય અંદાજ",
        "Milestones": "માઇલસ્ટોન",
        "MultipleAssignees": "એકથી વધુ સોંપનાર",
        "CustomFields": "કસ્ટમ ફીલ્ડ્સ",
        "TimeTracking": "સમય ટ્રેકિંગ",
        "AI": "એઆઈ"
    },
    "Tags": {
        "no_tags_found": "કોઈ ટૅગ્સ મળ્યા નથી",
        "search_or_create_new": "શોધો અથવા નવું બનાવો",
        "change_color": "રંગ બદલો",
        "delete_tag": "ટૅગ કાઢી નાખો",
        "delete_tag_desc": "શું તમે ખરેખર આ જગ્યા માંથી ટૅગ કાઢી નાખવા માંગો છો?",
        "note_msg": "નવો ટૅગ બનાવવા માટે એન્ટર દબાવો",
        "This_tag_has_already_been_added": "આ ટૅગ પહેલેથી જ ઉમેરવામાં આવ્યો છે",
        "Tag_name_required": "ટૅગ નામ જરૂરી છે"
    },
    "Embeded": {
        "Anything": "કંઈપણ",
        "Sheets": "Google Sheets",
        "Docs": "Google Docs",
        "Youtube": "Youtube",
        "Figma": "Figma",
        "The_name_is_required": "નામ જરૂરી છે",
        "The_name_should_be_at_least_3_characters_long": "નામ ઓછામાં ઓછું 3 અક્ષરો લાંબું હોવું જોઈએ",
        "The_url_is_required": "URL જરૂરી છે",
        "Please_enter_valid_url": "કૃપા કરીને માન્ય URL દાખલ કરો",
        "URL_already_exists": "URL પહેલેથી જ અસ્તિત્વમાં છે",
        "The_Html_code_is_required": "HTML કોડ જરૂરી છે",
        "name_already_exists": "આ નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "to_unlock_embed_view": "એમ્બેડ દૃશ્ય અનલૉક કરવા માટે"
    },
    "ViewListdescription": {
        "list_view": "તમારા કાર્યોને ગોઠવવા માટે યાદી દૃશ્યનો ઉપયોગ કરો – સૉર્ટ, ફિલ્ટર, જૂથ, અને કૉલમને કસ્ટમાઇઝ કરો.",
        "kanban_view": "તમારો સંપૂર્ણ બોર્ડ બનાવો અને કૉલમ વચ્ચે કાર્યો સરળતાથી ડ્રેગ-એન્ડ-ડ્રોપ કરો.",
        "projectdetail_view": "તમારી ટીમને વિગતવાર સમજવા માટે પ્રારંભિક આવશ્યકતાઓ, ચેકલિસ્ટ અને જોડાણો ઉમેરો.",
        "Comments_view": "તમારી ટીમ સાથે કોઈપણ બાબતે વાસ્તવિક સમયમાં ટિપ્પણીઓ ઉમેરો જેથી તેઓને સૂચિત કરવામાં આવે અને પ્રતિસાદ સાથે જવાબ આપી શકે.",
        "calender_view": "કૅલેન્ડર દૃશ્ય તમારી યોજના, શેડ્યૂલિંગ, અને સંસાધન વ્યવસ્થાપન માટેનું સ્થાન છે.",
        "table_view": "ટેબલ દૃશ્ય સાથે તમારા કાર્યોને સરળતાથી મેનેજ, અપડેટ અને ગોઠવો.",
        "workload_view": "તમારી ટીમની ક્ષમતા જુઓ, કોણ વધુ અથવા ઓછું છે અને તે મુજબ કાર્યો ફરીથી સોંપો.",
        "activitylog_view": "એક સ્થાન પર તમામ પ્રવૃત્તિઓનો સંકલિત દૃશ્ય મેળવો. તમે જે પ્રવૃત્તિ જુઓ છો તે માટે લોકો અને પ્રકારને ફિલ્ટર કરો.",
        "add_msg1": "એમ્બેડ દૃશ્ય સાથે તમારા કાર્યોની બાજુમાં એપ્સ અને વેબસાઇટ્સ ઉમેરો",
        "add_msg2": "સમય બચાવવા અને સંદર્ભ સ્વિચિંગ ઘટાડવા માટે.",
        "view_name": "દૃશ્ય નામ",
        "embed_URL": "એમ્બેડ URL",
        "embed_HTML": "એમ્બેડ HTML",
        "private_view": "ખાનગી દૃશ્ય"
    },
    "Filters": {
        "filter": "ફિલ્ટર્સ",
        "learnmorefilter": "ફિલ્ટર્સ વિશે વધુ જાણો",
        "pleaseselectvalid": "કૃપા કરીને બધી માન્ય વિકલ્પો પસંદ કરો",
        "confirm": "પુષ્ટિ કરો",
        "are_you_sure": "શું તમે ખરેખર કાઢી નાખવા માંગો છો",
        "clearall": "બધું સાફ કરો",
        "addfilter": "ફિલ્ટર ઉમેરો",
        "where": "ક્યાં",
        "filtering_field": "ફિલ્ટરિંગ ફીલ્ડ",
        "no_date_found": "કોઈ તારીખ મળી નથી",
        "save_this_filters": "આ ફિલ્ટર્સ સાચવો",
        "save_filter": "ફિલ્ટર સાચવો",
        "save": "સાચવો",
        "update_filter": "ફિલ્ટર અપડેટ કરો",
        "my_filter": "મારો ફિલ્ટર",
        "no_data_found": "કોઈ ડેટા મળ્યો નથી",
        "show_result": "પરિણામ બતાવો",
        "save_filters": "ફિલ્ટર્સ સાચવો",
        "filter_by": "દ્વારા ફિલ્ટર કરો",
        "projects": "પ્રોજેક્ટ્સ",
        "teams": "ટીમો",
        "user": "વપરાશકર્તા",
        "no_comment_found": "કોઈ ટિપ્પણી મળી નથી",
        "no_project_found": "કોઈ પ્રોજેક્ટ મળ્યો નથી",
        "no_file_found": "કોઈ ફાઇલ મળી નથી",
        "no_link_found": "કોઈ લિંક મળી નથી",
        "filter_operator": "ફિલ્ટર ઓપરેટર",
        "options": "વિકલ્પો",
        "priorities": "પ્રાથમિકતાઓ",
        "select_all": "બધા પસંદ કરો",
        "milestone_type": "માઇલસ્ટોન પ્રકાર",
        "comment_type": "ટિપ્પણી પ્રકાર",
        "a_to_z": "A થી Z",
        "no_files_found": "કોઈ ફાઇલો મળી નથી",
        "no_links_found": "કોઈ લિંક્સ મળી નથી",
        "no_links_or_files_found": "કોઈ લિંક્સ અથવા ફાઇલો મળી નથી",
        "z_to_a": "Z થી A",
        "sort_by": "દ્વારા સૉર્ટ કરો",
        "A-Z": "A-Z",
        "Ascending": "આરોહી",
        "Descending": "અવરોહી",
        "No": "ના",
        "Yes": "હા",
        "Z-A": "Z-A",
        "Save_this_Filter": "આ ફિલ્ટર સાચવો",
        "Enter_Filter_Name": "ફિલ્ટર નામ દાખલ કરો",
        "Select_Options": "વિકલ્પો પસંદ કરો",
        "Equal_To": "સમાન",
        "Greater_Than": "વધુ",
        "Is": "છે",
        "Less_Than": "ઓછું",
        "Clear_All": "બધું સાફ કરો",
        "select_assignee": "સોંપનાર પસંદ કરો",
        "select_project_types": "પ્રોજેક્ટ પ્રકારો પસંદ કરો",
        "unselect_all": "બધા પસંદગી દૂર કરો",
        "are_you_suredelete": "શું તમે ખાતરીથી કાઢી નાખવા માંગો છો?",
        "Not_Equals_To": "નથી"
    },
    "conformationmsg": {
        "archive": "યાદી આર્કાઇવ કરી શકાય છે જેથી તે દૃશ્યમાંથી છુપાય પરંતુ કોઈપણ સમયે પુનઃસ્થાપિત કરી શકાય. જ્યારે તમે યાદી આર્કાઇવ કરો છો ત્યારે બધા કાર્યો રાખવામાં આવે છે અને શોધી શકાય છે.",
        "delete": "આ પ્રોજેક્ટના કાર્યો અને ટેમ્પલેટ્સ બધા કાઢી નાખવામાં આવશે. તમે ખરેખર બધા કાર્યો, ટેમ્પલેટ્સ અને આ પ્રોજેક્ટ કાઢી નાખવા માંગો છો તેની પુષ્ટિ કરવા માટે પ્રોજેક્ટ નામ ટાઇપ કરો.",
        "archive0mesg": "તમે ખરેખર આ પ્રોજેક્ટ બંધ કરવા માંગો છો તેની પુષ્ટિ કરવા માટે પ્રોજેક્ટ નામ ટાઇપ કરો",
        "sprintclosemsg": "તમે ખરેખર આ સ્પ્રિન્ટ બંધ કરવા માંગો છો તેની પુષ્ટિ કરવા માટે સ્પ્રિન્ટ નામ ટાઇપ કરો",
        "type": "પ્રકાર",
        "are_you_sure": "શું તમે ખાતરી કરો છો?",
        "no_revert_msg": "તમે આને પાછું કરી શકશો નહીં!",
        "yes_delete": "હા, તેને કાઢી નાખો!",
        "task_will_become_subtasks_of": "કાર્ય ઉપકાર્ય બની જશે",
        "Are_you_sure_you_want_to_delete": "શું તમે ખરેખર કાઢી નાખવા માંગો છો",
        "subtasks_will_become_subtasks_of": "ઉપકાર્યો ઉપકાર્યો બની જશે",
        "unlock_board_view": "બોર્ડ દૃશ્ય અનલૉક કરવા માટે",
        "unlock_project_detail_view": "પ્રોજેક્ટ વિગતવાર દૃશ્ય અનલૉક કરવા માટે",
        "unlock_table_view": "ટેબલ દૃશ્ય અનલૉક કરવા માટે",
        "unlock_workload_view": "કામનો ભાર દૃશ્ય અનલૉક કરવા માટે",
        "to_unlock_tracker_timesheet": "ટ્રેકર સમય પત્રક અનલૉક કરવા માટે",
        "to_unlock_user_timesheet": "વપરાશકર્તા સમય પત્રક અનલૉક કરવા માટે",
        "unlock_calendar_view": "કેલેન્ડર દ્રશ્ય અનલૉક કરવા માટે"
    },
    "Description": {
        "description": "વર્ણન",
        "edit": "સંપાદિત કરો",
        "add_description": "વર્ણન ઉમેરો",
        "show_more": "વધુ બતાવો",
        "show_less": "ઓછું બતાવો",
        "description_placeholder": "કંઈક લખો અથવા કમાન્ડ્સ અને AI ક્રિયા માટે '/' ટાઇપ કરો",
        "saved": "સાચવેલ"
    },
    "Checklist": {
        "checklist": "ચેકલિસ્ટ",
        "add_checklist": "ચેકલિસ્ટ ઉમેરો",
        "suggest_checklists": "ચેકલિસ્ટ સૂચવો",
        "Checklists": "ચેકલિસ્ટ",
        "to_unlock_checklist": "ચેકલિસ્ટ અનલૉક કરવા માટે"
    },
    "Attachments": {
        "attachments": "જોડાણો",
        "drag_file": "અહીં, તમે ફાઇલોને ડ્રેગ અને ડ્રોપ પણ કરી શકો છો.",
        "see_all": "બધું જુઓ",
        "drop_file": "ફાઇલોને જોડવા માટે અહીં ડ્રોપ કરો અથવા",
        "browse": "બ્રાઉઝ કરો",
        "no_preview_found": "કોઈ પૂર્વાવલોકન મળ્યું નથી",
        "show_all_pages": "બધા પૃષ્ઠો બતાવો",
        "drop_here": "અહીં ડ્રોપ કરો"
    },
    "Milestone": {
        "milestone": "માઇલસ્ટોન",
        "milestone_name": "માઇલસ્ટોન નામ",
        "status_date": "સ્થિતિ તારીખ",
        "total_amount": "કુલ રકમ",
        "are_you_sure": "શું તમે ખરેખર માઇલસ્ટોન કાઢી નાખવા માંગો છો",
        "add_new": "નવું ઉમેરો",
        "mileston_status": "માઇલસ્ટોન સ્થિતિ",
        "project_name": "પ્રોજેક્ટ નામ",
        "end_date": "અંતિમ તારીખ",
        "start_date": "પ્રારંભ તારીખ",
        "estimated_release": "અંદાજિત રિલીઝ",
        "release_request_sent": "રિલીઝ વિનંતી મોકલવામાં આવી",
        "released": "રિલીઝ કરેલ",
        "not_funded": "ફંડેડ નથી",
        "funded": "ફંડેડ",
        "project_milestone_Status": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ",
        "milestone_status_name": "માઇલસ્ટોન સ્થિતિ નામ",
        "date_displaye": "કૅલેન્ડરમાં દર્શાવેલી તારીખ",
        "past": "ભૂતકાળ",
        "feature": "ભવિષ્ય",
        "milestone_weekly_range": "માઇલસ્ટોન સાપ્તાહિક શ્રેણી",
        "file_extensions": "ફાઇલ એક્સટેન્શન",
        "avatar": "અવતાર",
        "adding_estimated": "અંદાજિત કલાક ઉમેરો",
        "range": "શ્રેણી",
        "user": "વપરાશકર્તા",
        "refunded_amount": "પરતફેર રકમ",
        "Max_2_decimal_places_allowed": "મહત્તમ 2 દશાંશ સ્થાન મંજૂર છે",
        "The_refunded_amount_field_should_not_be_more_then_amount": "પરતફેર રકમ ફીલ્ડ રકમ કરતાં વધુ ન હોવી જોઈએ",
        "Amount_field_should_not_be_smaller_than_the_refunded_amount": "રકમ ફીલ્ડ પરતફેર રકમ કરતાં નાની ન હોવી જોઈએ",
        "The_minute_field_must_be_59_or_less": "મિનિટ ફીલ્ડ 59 અથવા ઓછું હોવું જોઈએ",
        "The_hours_field_is_required": "કલાક ફીલ્ડ જરૂરી છે",
        "Name_already_exists": "નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "The_milestone_status_field_is_required": "માઇલસ્ટોન સ્થિતિ ફીલ્ડ જરૂરી છે",
        "The_milestone_status_field_must_be_at_leat_characters": "માઇલસ્ટોન સ્થિતિ ફીલ્ડ ઓછામાં ઓછા 3 અક્ષરો હોવી જોઈએ",
        "actual_amount": "વાસ્તવિક રકમ",
        "partially_refunded": "આંશિક પરતફેર",
        "refunded_amount_should_not_exceed_amount": "પરતફેર રકમ ફીલ્ડ રકમ કરતાં વધુ ન હોવી જોઈએ",
        "total_partially_refunded": "કુલ આંશિક પરતફેર",
        "field_should_not_be_smaller_than_refund_amount": "ફીલ્ડ પરતફેર રકમ કરતાં નાની ન હોવી જોઈએ",
        "white_color_not_allowed": "સફેદ રંગ મંજૂર નથી. કૃપા કરીને માન્ય રંગ પસંદ કરો",
        "billing": "બિલિંગ",
        "per_hour": "પ્રતિ કલાક",
        "adding_taskPlanning": "કાર્ય યોજના ઉમેરો"
    },
    "Comment": {
        "created_by": "દ્વારા બનાવેલ",
        "created_on": "બનાવેલ તારીખ",
        "task_name": "કાર્ય નામ"
    },
    "UserTimesheet": {
        "back_projects": "પ્રોજેક્ટ પર પાછા જાઓ",
        "user_timesheet": "વપરાશકર્તા સમય પત્રક",
        "back": "પાછા",
        "tracked_time": "ટ્રેક કરેલ સમય",
        "manual_time": "મેન્યુઅલ સમય",
        "users": "વપરાશકર્તાઓ",
        "logged": "લૉગ કરેલ",
        "hours": "કલાક",
        "estimated": "અંદાજિત",
        "no_records_found": "કોઈ રેકોર્ડ મળ્યા નથી",
        "project_timesheet": "પ્રોજેક્ટ સમય પત્રક",
        "tracker_timesheet": "ટ્રેકર સમય પત્રક",
        "workload_timesheet": "કામનો ભાર સમય પત્રક",
        "milestone_reports": "માઇલસ્ટોન અહેવાલ",
        "add_time": "સમય ઉમેરો",
        "add_time_log": "સમય લોગ ઉમેરો",
        "edit_time_log": "સમય લોગ સંપાદિત કરો",
        "Teams": "ટીમો",
        "Users": "વપરાશકર્તાઓ",
        "Projects": "પ્રોજેક્ટ્સ",
        "task_planning": "કાર્ય યોજના",
        "task_remaining_planning": "બાકી કલાકો",
        "planned": "યોજનાબદ્ધ"
    },
    "ProjectWorkplace": {
        "msg1": "પ્રોજેક્ટ સભ્યો સાથે શેર કરી શકાય છે. તમે પ્રોજેક્ટ બનાવ્યા પછી ફોલ્ડર્સ, લિસ્ટ્સ અને કાર્યોમાં મહેમાનો ઉમેરી શકો છો.",
        "msg2": "હાલમાં, ખાનગી અથવા જાહેર પ્રોજેક્ટ્સ બનાવવા માટે કોઈ યોજના નથી. જો તમે પ્રોજેક્ટ શરૂ કરવા માંગતા હો, તો તમારો પ્લાન અપગ્રેડ કરવો જરૂરી છે."
    },
    "CustomField": {
        "custom_field": "કસ્ટમ ફીલ્ડ",
        "create_custom_field": "કસ્ટમ ફીલ્ડ બનાવો",
        "lable": "લેબલ",
        "action": "ક્રિયા",
        "add_custom_field": "કસ્ટમ ફીલ્ડ ઉમેરો",
        "add_new_custom_field": "નવું કસ્ટમ ફીલ્ડ ઉમેરો",
        "field_name": "ક્ષેત્રનું નામ",
        "date_created": "બનાવવાની તારીખ",
        "add_another_item": "બીજી આઇટમ ઉમેરો",
        "choose_ready_made_list": "વિકલ્પની તૈયાર યાદી પસંદ કરો (દા.ત. દિવસો, મહિનાઓ, વગેરે)",
        "predefined_options": "પૂર્વવ્યાખ્યાયિત વિકલ્પો",
        "selected_by_default": "મૂળભૂત રીતે પસંદ કરેલ",
        "allow_time_with_date": "વપરાશકર્તાઓને તારીખ સાથે સમયનો ઉલ્લેખ કરવાની મંજૂરી આપો.",
        "date_format": "તારીખ ફોર્મેટ",
        "days_of_week": "અઠવાડિયાના દિવસો",
        "past_and_future": "ભૂતકાળ અને ભવિષ્ય",
        "select_date_format": "તારીખ ફોર્મેટ પસંદ કરો. D નો અર્થ દિવસ, M મહિનો અને Y વર્ષ માટે વપરાય છે.",
        "select_dates_past_future": "વપરાશકર્તાઓને ભૂતકાળ અથવા ભવિષ્યની તારીખો પસંદ કરવા દો",
        "select_time_format": "સમય ફોર્મેટ પસંદ કરો",
        "time_format": "સમય ફોર્મેટ",
        "unchecking_day_calendar": "એક દિવસને અનચેક કરવાથી તે કેલેન્ડરમાં અનુપલબ્ધ થઈ જશે",
        "future": "ભાવિ",
        "past": "ભૂતકાળ",
        "enter_maximum_limit": "મહત્તમ મર્યાદા દાખલ કરો",
        "enter_minimum_limit": "ન્યૂનતમ મર્યાદા દાખલ કરો",
        "limit_minimum_or_maximum_value": "આ ક્ષેત્ર માટે મંજૂર લઘુત્તમ અથવા મહત્તમ મૂલ્યને મર્યાદિત કરો",
        "maximum_limit_type_not_allowed_value": "મહત્તમ મર્યાદા પ્રકાર માટે દાખલ કરેલ મૂલ્ય માન્ય મૂલ્ય નથી.",
        "maximum_value_should_be_greater_than_minimum_value": "મહત્તમ મૂલ્ય ન્યૂનતમ મૂલ્ય કરતાં વધુ હોવું જોઈએ",
        "minimum_limit_type_not_allowed_value": "ન્યૂનતમ મર્યાદા પ્રકાર માટે દાખલ કરેલ મૂલ્ય માન્ય મૂલ્ય નથી.",
        "minimum_value_should_not_be_greater_than_maximum_value": "ન્યૂનતમ મૂલ્ય મહત્તમ મૂલ્ય કરતાં વધુ ન હોવું જોઈએ",
        "no_country_found": "કોઈ દેશ મળ્યો નથી",
        "enter_maximum_limit_type": "મહત્તમ મર્યાદા પ્રકાર દાખલ કરો",
        "enter_minimum_limit_type": "ન્યૂનતમ મર્યાદા પ્રકાર દાખલ કરો",
        "limit_minimum_or_maximum_text_allowed": "આ ફીલ્ડમાં લઘુત્તમ અથવા મહત્તમ ટેક્સ્ટની મંજૂરી આપો",
        "max_should_be_greater_than_min": "મહત્તમ ન્યૂનતમ કરતાં વધુ હોવું જોઈએ",
        "min_should_be_less_than_max": "ન્યૂનતમ મહત્તમ કરતાં ઓછું હોવું જોઈએ",
        "separator": "વિભાજક",
        "countryCode": "દેશના કોડમાં ફેરફાર કરવા માટે તેને ચાલુ કરો."
    },
    "Category": {
        "cateory_name": "કેટેગરી નામ",
        "create_category": "કેટેગરી બનાવો",
        "upgradeplanemsg": "આ સુવિધા ઍક્સેસ કરવા માટે કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો.",
        "create_channel": "ચેનલ બનાવો",
        "no_chat_found": "કોઈ ચેટ્સ મળ્યા નથી"
    },
    "Channel": {
        "create_channel": "ચેનલ બનાવો",
        "msg1": "તમે મહત્તમ જાહેર અને ખાનગી ચેનલ બનાવવાની મર્યાદા પર પહોંચી ગયા છો. આ સુવિધા ઍક્સેસ કરવા માટે કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો",
        "channel_name": "ચેનલ નામ",
        "icons": "આઇકન્સ",
        "or": "અથવા",
        "only_share_with": "માત્ર સાથે શેર કરો",
        "private_channel": "ખાનગી ચેનલ",
        "msg2": "માત્ર પસંદ કરેલા સભ્યો અને ભૂમિકાઓ આ ચેનલ જોઈ શકશે",
        "allowmsg2": "આ ચેનલમાં સભ્યોને સંદેશાઓ મોકલવાની મંજૂરી આપે છે",
        "send_messages": "સંદેશાઓ મોકલો",
        "choose_to_upload": "અપલોડ કરવા માટે છબી પસંદ કરો",
        "private_channel_limit_reached": "તમે ખાનગી ચેનલ બનાવવાની મર્યાદા પર પહોંચી ગયા છો. તમે માત્ર જાહેર ચેનલ બનાવી શકો છો. જો તમે ખાનગી ચેનલ બનાવવા માંગતા હો, તો કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો.",
        "public_channel_limit_reached": "તમે જાહેર ચેનલ બનાવવાની મર્યાદા પર પહોંચી ગયા છો. તમે માત્ર ખાનગી ચેનલ બનાવી શકો છો. જો તમે જાહેર ચેનલ બનાવવા માંગતા હો, તો કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો."
    },
    "Templates": {
        "delete_template": "ટેમ્પલેટ કાઢી નાખો",
        "project_status": "પ્રોજેક્ટ સ્થિતિ",
        "task_status": "કાર્ય સ્થિતિ",
        "no_app_selected": "કોઈ એપ્સ પસંદ કરેલ નથી",
        "default_views": "દૃશ્યો માટે ડિફોલ્ટ સેટિંગ",
        "apps": "એપ્સ",
        "add_new_templete": "નવું ટેમ્પલેટ ઉમેરો",
        "templates": "ટેમ્પલેટ્સ",
        "s": "s",
        "template_name": "ટેમ્પલેટ નામ",
        "upload_image": "છબી અપલોડ કરો",
        "all_good": "બધું સારું",
        "create_template": "ટેમ્પલેટ બનાવો",
        "new_template": "નવું ટેમ્પલેટ",
        "remove": "દૂર કરો",
        "enable_apps": "એપ્સ સક્ષમ કરો",
        "Turn": "ટર્ન",
        "all_apps": "બધા એપ્સ",
        "off": "બંધ",
        "on": "ચાલુ",
        "upload": "અપલોડ",
        "save_template": "ટેમ્પલેટ સાચવો",
        "setup_status": "કાર્યો માટેની સ્થિતિ સેટ કરો",
        "what_task": "તમે કઈ કાર્ય સ્થિતિ ઇચ્છો છો",
        "select_task_status": "કાર્ય સ્થિતિ પસંદ કરો",
        "delete_template_confirmation": "શું તમે ખરેખર ટેમ્પલેટ કાઢી નાખવા માંગો છો?",
        "ai_sidebar_title": "AI સાથે ટેમ્પલેટ બનાવો",
        "ai_label_category": "શ્રેણી",
        "ai_label_description": "વર્ણન",
        "ai_button_text_requested_changes": "ફેરફાર માંગો",
        "ai_min_view_msg_text": "ઓછામાં ઓછું એક વ્યૂ જરૂરી છે",
        "ai_min_msg_text": "ઓછામાં ઓછા 10 અક્ષરો જરૂરી છે",
        "ai_before_desc_placeholder": "ટેમ્પલેટ જનરેટ કરવા માટે ઉપયોગનો વર્ણન દાખલ કરો",
        "ai_after_desc_placeholder": "અહીં તમે સંબંધિત ફેરફાર માટે કંઈ પણ પૂછતા રહી શકો છો",
        "try_with_ai": "એઆઈ સાથે પ્રયાસ કરો",
        "msg_search_result_found": "અહીં કેટલીક સૂચિત ટેમ્પલેટ્સ છે જે તમારા આવશ્યકતાઓને અનુરૂપ છે. તમે કોઈપણ પસંદ કરી શકો છો અથવા AI નો ઉપયોગ કરીને નવી બનાવવા માટે, ફક્ત ક્લિક કરો",
        "msg_search_result_not_found": "સંબંધિત કોઈ ટેમ્પલેટ્સ મળ્યાં નહીં. AI નો ઉપયોગ કરીને એક બનાવવા માટે, ફક્ત ક્લિક કરો"
    },
    "Settings": {
        "add_new_projects": "નવું પ્રોજેક્ટ ઉમેરો",
        "task_priority": "કાર્ય પ્રાથમિકતા",
        "maximum_image_size": "મહત્તમ છબી કદ",
        "warning": "ચેતવણી",
        "cant_delete": "કાઢી શકાતું નથી",
        "priority_in_use": "વપરાશકર્તા PRIORITY_NAME પ્રાથમિકતા ડિલીટ કરી શકતા નથી કારણ કે તે પહેલેથી જ ઉપયોગમાં છે.",
        "company_name": "કંપની નામ",
        "phone": "ફોન",
        "country": "દેશ",
        "state": "રાજ્ય",
        "city": "શહેર",
        "select_date_format": "તારીખ ફોર્મેટ પસંદ કરો",
        "save_changes": "ફેરફારો સાચવો",
        "currencies": "કરન્સી",
        "add_remove_cur": "કરન્સી ઉમેરો/દૂર કરો",
        "change_image": "છબી બદલો",
        "Priorities_already_Exists": "પ્રાથમિકતાઓ પહેલેથી જ અસ્તિત્વમાં છે",
        "The_priority_image_field_is_required": "પ્રાથમિકતા છબી ફીલ્ડ જરૂરી છે",
        "The_priority_name_field_is_required": "પ્રાથમિકતા નામ ફીલ્ડ જરૂરી છે",
        "The_priority_name_field_must_be_at_least": "પ્રાથમિકતા નામ ફીલ્ડ ઓછામાં ઓછા 3 અક્ષરો હોવી જોઈએ",
        "The file extension field is required": "ફાઇલ એક્સટેન્શન ફીલ્ડ જરૂરી છે",
        "The_file_extension_field_must_be_at_least": "ફાઇલ એક્સટેન્શન ફીલ્ડ ઓછામાં ઓછા 3 અક્ષરો હોવી જોઈએ",
        "file_extension_is_not_supported": "ફાઇલ એક્સટેન્શન સપોર્ટેડ નથી",
        "file_extension_already_Exists": "ફાઇલ એક્સટેન્શન પહેલેથી જ અસ્તિત્વમાં છે",
        "The_file_extension_field_is_required": "ફાઇલ એક્સ્ટેંશનનું ક્ષેત્ર આવશ્યક છે."
    },
    "Members": {
        "invite": "આમંત્રણ",
        "all_members": "બધા સભ્યો",
        "removed_members": "દૂર કરેલા સભ્યો",
        "name": "નામ",
        "role": "ભૂમિકા",
        "last_active": "છેલ્લે સક્રિય",
        "time_tracker": "સમય ટ્રેકર",
        "settings": "સેટિંગ્સ",
        "removeuser": "વપરાશકર્તાને દૂર કરો",
        "adduser": "વપરાશકર્તા ઉમેરો",
        "invite_user": "વપરાશકર્તાને આમંત્રિત કરો",
        "remove_request": "વિનંતી દૂર કરો",
        "resend_invitation": "આમંત્રણ ફરીથી મોકલો",
        "cancel_invitation": "આમંત્રણ રદ કરો",
        "Invitation_mail_sent_sucessfully": "આમંત્રણ મેલ સફળતાપૂર્વક મોકલવામાં આવ્યો",
        "confirm_change_user_designation": "શું તમે ખરેખર આ વપરાશકર્તાની નિમણૂક બદલવા માંગો છો",
        "confirm_change_user_role": "શું તમે ખરેખર આ વપરાશકર્તાની ભૂમિકા બદલવા માંગો છો",
        "Import_users_from_csv": "CSV માંથી વપરાશકર્તાઓ આયાત કરો"
    },
    "Upgrades": {
        "take_next_step": "તમારા કામ સાથે આગળનું પગલું લો",
        "you_are_on": "તમે હાલમાં છો",
        "per_year": "પ્રતિ વર્ષ",
        "per_month": "પ્રતિ મહિનો",
        "current_plane": "વર્તમાન પ્લાન",
        "per_member": "પ્રતિ સભ્ય",
        "and_much_more": "અને ઘણું વધુ",
        "upgrade_to": "અપગ્રેડ કરો",
        "select_payment_method": "ચુકવણી પદ્ધતિ પસંદ કરો",
        "plan": "પ્લાન",
        "plane_upgrade": "પ્લાન સફળતાપૂર્વક અપગ્રેડ",
        "plane_upgrade_msg": "પ્લાન અપગ્રેડ સફળ! તમારું સબ્સ્ક્રિપ્શન અપગ્રેડ કરવામાં આવ્યું છે. કૃપા કરીને ફેરફારોને દરેક જગ્યાએ અસરકારક થવા માટે 2 થી 3 મિનિટની મંજૂરી આપો, ખાતરી કરો કે તમે વિસ્તૃત સુવિધાઓ અને સુધારાઓનો સંપૂર્ણ આનંદ માણી શકો!",
        "something_wrong": "કંઈક ખોટું થયું કૃપા કરીને ફરી પ્રયાસ કરો",
        "unsucessfull_msg": "પ્લાન અપગ્રેડ નિષ્ફળ. અમે તમારો પ્લાન અપગ્રેડ કરતી વખતે સમસ્યા આવી. કૃપા કરીને ફરી પ્રયાસ કરો અથવા સહાય માટે સપોર્ટનો સંપર્ક કરો.",
        "upgrade_your_plan": "તમારો પ્લાન અપગ્રેડ કરો",
        "to_unlock_custom_field": "કસ્ટમ ફીલ્ડ અનલૉક કરવા માટે",
        "unlimited": "અનલિમિટેડ",
        "the_feature_not_available": "આ સુવિધા તમારા વર્તમાન પ્લાન પર ઉપલબ્ધ નથી",
        "unlock_project_permission": "પ્રોજેક્ટ પરવાનગીઓ અનલૉક કરવા માટે",
        "unlock_custom_field": "કસ્ટમ ફીલ્ડ અનલૉક કરવા માટે",
        "to_unlock_milestone": "માઇલસ્ટોન અનલૉક કરવા માટે",
        "to_unlock_milestone_report": "માઇલસ્ટોન અહેવાલ અનલૉક કરવા માટે",
        "to_unlock_security": "સુરક્ષા અને પરવાનગીઓ અનલૉક કરવા માટે",
        "to_unlock_team": "ટીમને અનલોક કરવા",
        "to_unlcok_project": "પ્રોજેક્ટ અનલૉક કરવા માટે",
        "You_have_reached_the_free_plan_limit": "તમે PLAN_NAME મર્યાદા સુધી પહોંચી ગયા છો",
        "require_upgrade_message": "તમે PROJECT_NAME યોજનામાં PROJECT_COUNT પ્રોજેક્ટ્સ બનાવી શકો છો. વધુ બોર્ડ્સ બનાવવા માટે તમારી યોજના અપગ્રેડ કરો.",
        "are_you_sure_you_want_to_update": "શું તમે ખરેખર અપડેટ કરવા માંગો છો?",
        "find_out_whats_included_in_this_update": "આ અપડેટમાં શું સામેલ છે તે શોધો",
        "improved_performance": "સુધારેલી કામગીરી",
        "install_now": "હવે ઇન્સ્ટોલ કરો",
        "later": "પછી",
        "please_see_below_for_a_list_of_changes_to_the_features": "કૃપા કરીને સુવિધાઓમાં ફેરફારોની સૂચિ માટે નીચે જુઓ.",
        "to_integrate_new_services_into_an_alian_hub": "નવી સેવાઓને હાઇફન ઓઆઈ પ્રોમાં એકીકૃત કરવા માટે.",
        "whats_new": "શું નવું છે?",
        "check_to_agree_with_above_points": "ઉપરના મુદ્દાઓ સાથે સંમત થવા માટે ચકાસો",
        "general_notes": "સામાન્ય નોંધો",
        "update_now": "હવે અપડેટ કરો",
        "unlock_channel": "ચેનલ અનલોક કરવા માટે",
        "unlock_chat": "ચેટ અનલોક કરવા માટે",
        "unlock_one_chat": "એકથી એક ચેટ અનલોક કરવા માટે",
        "public_private_creation_time_limit_reached": "તમે પ્રોજેક્ટ બનાવવાની મર્યાદા સુધી પહોંચી ગયા છો. જો તમે પ્રોજેક્ટ બનાવવા માંગતા હો, તો કૃપા કરીને તમારી યોજના અપગ્રેડ કરો.",
        "public_creation_time_limit_reached": "તમે જાહેર પ્રોજેક્ટ બનાવવાની મર્યાદા સુધી પહોંચી ગયા છો. તમે ફક્ત ખાનગી પ્રોજેક્ટ્સ બનાવી શકો છો. જો તમે જાહેર પ્રોજેક્ટ બનાવવા માંગતા હો, તો કૃપા કરીને તમારી યોજના અપગ્રેડ કરો.",
        "private_creation_time_limit_reached": "તમે ખાનગી પ્રોજેક્ટ બનાવવાની મર્યાદા સુધી પહોંચી ગયા છો. તમે ફક્ત જાહેર પ્રોજેક્ટ્સ બનાવી શકો છો. જો તમે ખાનગી પ્રોજેક્ટ બનાવવા માંગતા હો, તો કૃપા કરીને તમારી યોજના અપગ્રેડ કરો."
    },
    "Permissions": {
        "advanced_permission": "અદ્યતન પરવાનગીઓ",
        "allow_admins": "એડમિનને ખાનગી જગ્યા મેનેજ કરવાની મંજૂરી આપો",
        "when_admin_enable": "જ્યારે સક્રિય કરવામાં આવે છે, ત્યારે એડમિન લોકોને ઉમેરવા/દૂર કરવા અને તમામ જગ્યા માટે માલિકી હસ્તાંતર કરવા સક્ષમ હશે.",
        "show_all_projects": "બધા પ્રોજેક્ટ્સ બતાવો",
        "when_user_enable": "જ્યારે સક્રિય કરવામાં આવે છે, ત્યારે વપરાશકર્તાઓ તમામ વૈશ્વિક પ્રોજેક્ટ્સ જોઈ શકશે.",
        "show_all_task": "બધા કાર્યો બતાવો",
        "when_user_enable_sprint": "જ્યારે સક્રિય કરવામાં આવે છે, ત્યારે વપરાશકર્તાઓ સ્પ્રિન્ટમાં તમામ કાર્યો જોઈ શકશે.",
        "own": "માલિક",
        "select": "પસંદ કરો",
        "Member": "સભ્ય",
        "Guest": "મહેમાન",
        "None": "કોઈ નથી",
        "Read": "વાંચો",
        "add_new_team": "નવી ટીમ ઉમેરો",
        "Read & Write": "વાંચો અને લખો",
        "Support": "સહાય",
        "select_priorities": "પ્રાથમિકતાઓ પસંદ કરો",
        "apply_permission": "પરવાનગી લાગુ કરો",
        "project_permission_description": "વૈશ્વિક પરવાનગીઓ ઓવરરાઇડ કરવા માટે, તે ડિફોલ્ટ દ્વારા અક્ષમ છે. તે સક્રિય કર્યા પછી, તમે પ્રોજેક્ટ અને કાર્ય પરવાનગીઓ મેનેજ કરી શકો છો. જો તે અક્ષમ છે, તો વૈશ્વિક પરવાનગીઓ લાગુ થાય છે",
        "project_permission_title_disable": "આ પ્રોજેક્ટ માટે કસ્ટમ પરવાનગીઓ આપવાની ક્ષમતા અક્ષમ કરવામાં આવશે",
        "project_permission_title_enable": "આ પ્રોજેક્ટ માટે કસ્ટમ પરવાનગીઓ આપવાની ક્ષમતા સક્રિય કરવામાં આવશે",
        "reset_permission": "પરવાનગી રીસેટ કરો"
    },
    "subProjectRulesNames": {
        "Project_List": "પ્રોજેક્ટ યાદી",
        "Project_Create": "પ્રોજેક્ટ બનાવો",
        "Project_Name_Edit": "પ્રોજેક્ટ નામ સંપાદિત કરો",
        "Project_Sprint_Create": "પ્રોજેક્ટ સ્પ્રિન્ટ બનાવો",
        "Project_folder_Create": "પ્રોજેક્ટ ફોલ્ડર બનાવો",
        "Project_folder_Name_Edit": "પ્રોજેક્ટ ફોલ્ડર નામ સંપાદિત કરો",
        "Project_sprint_Name_Edit": "પ્રોજેક્ટ સ્પ્રિન્ટ નામ સંપાદિત કરો",
        "Project_Details": "પ્રોજેક્ટ વિગતો",
        "Project_Status_Change": "પ્રોજેક્ટ સ્થિતિ બદલો",
        "Project_Assignee": "પ્રોજેક્ટ સોંપનાર",
        "Project_Category": "પ્રોજેક્ટ કેટેગરી",
        "Proejct_Source": "પ્રોજેક્ટ સ્રોત",
        "Project_Type": "પ્રોજેક્ટ પ્રકાર",
        "Project_Currency": "પ્રોજેક્ટ કરન્સી",
        "Project_Amount": "પ્રોજેક્ટ રકમ",
        "Project_Start Date": "પ્રોજેક્ટ પ્રારંભ તારીખ",
        "Project_End Date": "પ્રોજેક્ટ અંતિમ તારીખ",
        "Project_Due Date": "પ્રોજેક્ટ નિયત તારીખ",
        "Project_Close": "પ્રોજેક્ટ બંધ",
        "Project_Description": "પ્રોજેક્ટ વર્ણન",
        "Project_Checklist": "પ્રોજેક્ટ ચેકલિસ્ટ",
        "Project_Checklist_Assign/remove": "પ્રોજેક્ટ ચેકલિસ્ટ સોંપો/દૂર કરો",
        "Project_Attachments": "પ્રોજેક્ટ જોડાણો",
        "Project_Milestone": "પ્રોજેક્ટ માઇલસ્ટોન",
        "Task_list": "કાર્ય યાદી",
        "Task_Create": "કાર્ય બનાવો",
        "Sub_Task_Create": "ઉપકાર્ય બનાવો",
        "Task_Name_Edit": "કાર્ય નામ સંપાદિત કરો",
        "Task_Status": "કાર્ય સ્થિતિ",
        "Task_Assignee": "કાર્ય સોંપનાર",
        "Task_Priority": "કાર્ય પ્રાથમિકતા",
        "Task_Due_Date": "કાર્ય નિયત તારીખ",
        "Task_Estimated_Hours": "કાર્ય અંદાજિત કલાક",
        "Task_Description": "કાર્ય વર્ણન",
        "Task_Checklist": "કાર્ય ચેકલિસ્ટ",
        "Task_Checklist_Assign/remove": "કાર્ય ચેકલિસ્ટ સોંપો/દૂર કરો",
        "Task_Attachments": "કાર્ય જોડાણો",
        "Show_Tasks": "કાર્યો બતાવો",
        "Custom_Field": "કસ્ટમ ફીલ્ડ",
        "Edit_Company": "કંપની સંપાદિત કરો",
        "File_Extensions": "ફાઇલ એક્સટેન્શન",
        "Project_Milestone_Status": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ",
        "Invite_Member": "સભ્યને આમંત્રિત કરો",
        "Member_list": "સભ્ય યાદી",
        "Create_Team": "ટીમ બનાવો",
        "Team_List": "ટીમ યાદી",
        "Security_&_Permissions": "સુરક્ષા અને પરવાનગીઓ",
        "Role_Management": "ભૂમિકા વ્યવસ્થાપન",
        "Designation": "હોદ્દો",
        "Milestone_Weekly_Range": "માઇલસ્ટોન સાપ્તાહિક શ્રેણી",
        "User_Timesheet": "વપરાશકર્તા સમય પત્રક",
        "Project_Timesheet": "પ્રોજેક્ટ સમય પત્રક",
        "Workload__Timesheet": "કામનો ભાર સમય પત્રક",
        "Milestone_Report": "માઇલસ્ટોન અહેવાલ",
        "Project": "પ્રોજેક્ટ",
        "Task": "કાર્ય",
        "Company_Settings": "કંપની સેટિંગ્સ",
        "Sheet_Settings": "શીટ સેટિંગ્સ",
        "Team_Color": "ટીમ રંગ",
        "Team_Name": "ટીમ નામ",
        "Add_Member": "સભ્ય ઉમેરો",
        "Add_New_Designation": "નવો હોદ્દો ઉમેરો"
    },
    "Notification": {
        "Notification": "સૂચના",
        "notification_setting": "સૂચના સેટિંગ્સ",
        "browser": "બ્રાઉઝર",
        "mobile": "મોબાઇલ",
        "before": "પહેલાં",
        "chat": "ચેટ",
        "project": "પ્રોજેક્ટ",
        "tasks": "કાર્યો",
        "before_project_due_date": "પ્રોજેક્ટ નિયત તારીખ",
        "before_project_end_date": "પ્રોજેક્ટ અંતિમ તારીખ",
        "before_task_due_date": "કાર્ય નિયત તારીખ",
        "before_task_end_date": "કાર્ય અંતિમ તારીખ",
        "message_create": "સંદેશ બનાવો",
        "project_create": "પ્રોજેક્ટ બનાવો",
        "project_name": "પ્રોજેક્ટ નામ",
        "project_status_change": "પ્રોજેક્ટ સ્થિતિ બદલો",
        "project_assignee": "પ્રોજેક્ટ સોંપનાર",
        "project_lead": "પ્રોજેક્ટ લીડ",
        "project_category": "પ્રોજેક્ટ કેટેગરી",
        "project_source": "પ્રોજેક્ટ સ્રોત",
        "project_type": "પ્રોજેક્ટ પ્રકાર",
        "project_currency": "પ્રોજેક્ટ કરન્સી",
        "project_amount": "પ્રોજેક્ટ રકમ",
        "project_start_date": "પ્રોજેક્ટ પ્રારંભ તારીખ",
        "project_end_date": "પ્રોજેક્ટ અંતિમ તારીખ",
        "project_due_date": "પ્રોજેક્ટ નિયત તારીખ",
        "project_close": "પ્રોજેક્ટ બંધ",
        "project_description": "પ્રોજેક્ટ વર્ણન",
        "project_checklist": "પ્રોજેક્ટ ચેકલિસ્ટ",
        "project_checklist_assign": "પ્રોજેક્ટ ચેકલિસ્ટ સોંપો",
        "project_checklist_remove": "પ્રોજેક્ટ ચેકલિસ્ટ દૂર કરો",
        "project_attachments": "પ્રોજેક્ટ જોડાણો",
        "project_milestone": "પ્રોજેક્ટ માઇલસ્ટોન",
        "project_milestone_status_change": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ બદલો",
        "project_sprint_create": "પ્રોજેક્ટ સ્પ્રિન્ટ બનાવો",
        "project_folder_create": "પ્રોજેક્ટ ફોલ્ડર બનાવો",
        "comments_im_@mentioned_in": "ટિપ્પણીઓ હું {'@'}mentioned માં છું",
        "task_notification": "કાર્ય સૂચના",
        "task_create": "કાર્ય બનાવો",
        "task_edit": "કાર્ય સંપાદિત કરો",
        "task_status": "કાર્ય સ્થિતિ",
        "task_assignee": "કાર્ય સોંપનાર",
        "task_priority": "કાર્ય પ્રાથમિકતા",
        "task_type": "કાર્ય પ્રકાર",
        "task_due_date": "કાર્ય નિયત તારીખ",
        "task_description": "કાર્ય વર્ણન",
        "task_checklist": "કાર્ય ચેકલિસ્ટ",
        "task_checklist_assign": "કાર્ય ચેકલિસ્ટ સોંપો",
        "task_checklist_remove": "કાર્ય ચેકલિસ્ટ દૂર કરો",
        "task_attachments": "કાર્ય જોડાણો",
        "comments_Im_@mentioned_in": "ટિપ્પણીઓ હું {'@'}mentioned માં છું",
        "logged_hours_notification": "લૉગ કરેલ કલાક સૂચના",
        "after_3_hours_today_pending_hours": "આજે 3 કલાક પછી બાકી કલાક લૉગ સૂચના",
        "task_estimated_hours": "કાર્ય અંદાજિત કલાક"
    },
    "TimeTracker": {
        "TimeTracker": "સમય ટ્રેકર",
        "unlock": "તમારા ડેસ્કટોપ પર હાઇફન ઓઆઈ પ્રો ટ્રેકર સાથે બ્રહ્માંડને અનલૉક કરો!",
        "smooth": "સમય ટ્રેકિંગ સાથે પ્રોજેક્ટ્સ અથવા કાર્યો પર કામ કરતા વપરાશકર્તાઓ દ્વારા વિતાવેલા કલાકોને સરળતાથી ટ્રેક કરો.",
        "click": "ક્લિક કરો",
        "No_Record_Found": "કોઈ રેકોર્ડ મળ્યો નથી",
        "total": "કુલ",
        "screenshot_preview": "સ્ક્રીનશોટ પૂર્વાવલોકન",
        "log_time_found_no_screenshot": "લૉગ સમય મળ્યો છે, પરંતુ આ અવધિ માટે કોઈ સ્ક્રીનશોટ લેવામાં આવ્યો નથી"
    },
    "settingslider": {
        "Time Tracking": "સમય ટ્રેકિંગ",
        "Notifications": "સૂચનાઓ",
        "Company": "કંપની",
        "My Settings": "મારા સેટિંગ્સ",
        "Security & Permissions": "સુરક્ષા અને પરવાનગીઓ",
        "Upgrade": "અપગ્રેડ",
        "Custom Field Manager": "કસ્ટમ ફીલ્ડ મેનેજર",
        "Templates": "ટેમ્પલેટ્સ",
        "Projects": "પ્રોજેક્ટ્સ",
        "Teams": "ટીમો",
        "Members": "સભ્યો",
        "Settings": "સેટિંગ્સ",
        "Change Password": "પાસવર્ડ બદલો"
    },
    "Chat": {
        "welcome_message": "BRAND_NAME માં આપનું સ્વાગત છે",
        "msg2": "આ એક બ્રાન્ડ-નવું ગ્રુપ છે. અહીં તમને પ્રારંભ કરવા માટે કેટલીક પગલાં છે. વધુ માટે, અમારી પ્રારંભિક માર્ગદર્શિકા તપાસો",
        "chats": "ચેટ્સ",
        "favorites": "મનપસંદ",
        "CHANNELS": "ચેનલ્સ"
    },
    "Comments": {
        "unread_message": "વાંચી ન પડેલા સંદેશાઓ",
        "more": "વધુ",
        "less": "ઓછું",
        "edited": "સંપાદિત",
        "edit": "સંપાદિત કરો",
        "create_task": "કાર્ય બનાવો",
        "add_to_checklist": "ચેકલિસ્ટમાં ઉમેરો",
        "copy_message": "સંદેશ નકલ કરો",
        "reply": "જવાબ આપો",
        "message": "સંદેશ",
        "mark_unread": "વાંચી ન પડેલા તરીકે ચિહ્નિત કરો",
        "This_message_is_deleted": "આ સંદેશ કાઢી નાખવામાં આવ્યો છે",
        "You_deleted_this_message": "તમે આ સંદેશ કાઢી નાખ્યો છે",
        "no_user_found": "કોઈ વપરાશકર્તા મળ્યો નથી",
        "unlock_comment_view": "ટિપ્પણી દૃશ્ય અનલૉક કરવા માટે"
    },
    "PlaceHolder": {
        "enter_task_type": "કાર્ય પ્રકાર દાખલ કરો",
        "enter_task_status": "કાર્ય સ્થિતિ દાખલ કરો",
        "enter_project_status": "પ્રોજેક્ટ સ્થિતિ દાખલ કરો",
        "Enter_Project_Name": "પ્રોજેક્ટ નામ દાખલ કરો",
        "Enter_Key_Name": "કી નામ દાખલ કરો",
        "Select_Category": "કેટેગરી પસંદ કરો",
        "Select_Project_Due_Date": "પ્રોજેક્ટ નિયત તારીખ પસંદ કરો",
        "search": "શોધો",
        "search_here": "અહીં શોધો",
        "Type_here": "અહીં લખો",
        "Task_name": "કાર્ય નામ",
        "Add_description": "વર્ણન ઉમેરો",
        "Enter_Duplicate_Task_Name": "નકલ કાર્ય નામ દાખલ કરો",
        "Enter_Text": "લખાણ દાખલ કરો",
        "Enter_Amount": "રકમ દાખલ કરો",
        "Select": "પસંદ કરો",
        "Enter_Refund_Amount": "પરતફેર રકમ દાખલ કરો",
        "Enter_Milestone_Name": "માઇલસ્ટોન નામ દાખલ કરો",
        "Enter_sprint_name": "સ્પ્રિન્ટ નામ દાખલ કરો",
        "Enter_directory_name": "ડિરેક્ટરી નામ દાખલ કરો",
        "Rename_Tag": "ટૅગનું નામ બદલો",
        "Enter_Team_Name": "ટીમ નામ દાખલ કરો",
        "Duration_only_hours": "અવધિ માત્ર કલાક",
        "Enter_option": "વિકલ્પ દાખલ કરો",
        "Enter_View_Name": "દૃશ્ય નામ દાખલ કરો",
        "Enter_URL": "URL દાખલ કરો",
        "Enter_HTML": "HTML દાખલ કરો",
        "Enter_item_name": "+ આઇટમ નામ દાખલ કરો",
        "Add_an_item": "+ આઇટમ ઉમેરો",
        "Enter_Company_Name": "કંપની નામ દાખલ કરો",
        "Select_Country": "દેશ પસંદ કરો",
        "Enter_Template": "ટેમ્પલેટ દાખલ કરો",
        "Enter_Template_Name": "ટેમ્પલેટ નામ દાખલ કરો",
        "Project_key_must_be_unique": "પ્રોજેક્ટ કી અનન્ય હોવી જોઈએ",
        "Enter_zip": "ઝિપ દાખલ કરો",
        "Enter_GST_Number": "GST નંબર દાખલ કરો",
        "Enter_Milestone_Status": "માઇલસ્ટોન સ્થિતિ દાખલ કરો",
        "Enter_Priority_Name": "પ્રાથમિકતા નામ દાખલ કરો",
        "Enter_File_Extensions_Name": "ફાઇલ એક્સટેન્શન નામ દાખલ કરો",
        "Enter_Task_Name": "કાર્ય નામ દાખલ કરો",
        "Select_State": "રાજ્ય પસંદ કરો",
        "No_States": "કોઈ રાજ્યો નથી",
        "Select_City": "શહેર પસંદ કરો",
        "No_Cities": "કોઈ શહેરો નથી",
        "enter_category_name": "કેટેગરી નામ દાખલ કરો",
        "enter_channel_name": "ચેનલ નામ દાખલ કરો",
        "Pinned_messages": "પિન કરેલા સંદેશાઓ",
        "Search": "શોધો",
        "Search_by_name_or_email": "નામ અથવા ઇમેલ દ્વારા શોધો",
        "Invite_by_email": "ઇમેલ દ્વારા આમંત્રિત કરો",
        "Select_Designation": "હોદ્દો પસંદ કરો",
        "Select_Role": "ભૂમિકા પસંદ કરો",
        "Enter_designation": "હોદ્દો દાખલ કરો",
        "Enter_Description": "વર્ણન દાખલ કરો",
        "Add_New_Role": "નવી ભૂમિકા ઉમેરો",
        "Enter_role": "ભૂમિકા દાખલ કરો",
        "Enter_Field_Label": "ફીલ્ડ લેબલ દાખલ કરો",
        "Enter_Placeholder": "પ્લેસહોલ્ડર દાખલ કરો",
        "field_label": "ફીલ્ડ લેબલ",
        "placeholder": "પ્લેસહોલ્ડર",
        "Enter_Number": "નંબર દાખલ કરો"
    },
    "DuplicateTask": {
        "duplicate_task_name": "નકલ કાર્ય નામ",
        "what_do_you_copy": "તમે શું નકલ કરવા માંગો છો",
        "everything": "બધું",
        "no_assignee": "કોઈ સોંપનાર નથી",
        "no_watcher": "કોઈ વોચર નથી",
        "move_task": "કાર્ય ખસેડો",
        "mearge_task_into": "કાર્યમાં મર્જ કરો"
    },
    "Converttolist": {
        "are_you_sure_convert": "શું તમે ખરેખર આ કાર્યને યાદીમાં રૂપાંતરિત કરવા માંગો છો?",
        "important": "મહત્વપૂર્ણ",
        "you_will_lose": "તમે તમામ થ્રેડેડ ટિપ્પણીઓ ગુમાવશો. આ ક્રિયા પાછી કરી શકાશે નહીં",
        "convert_to_list": "યાદીમાં રૂપાંતરિત કરો"
    },
    "Billing": {
        "billing_details": "બિલિંગ વિગતો",
        "plan_details": "પ્લાન વિગતો",
        "next_msg": "આગામી ચૂકવવાપાત્ર રકમ છે",
        "due_on": "નિયત તારીખ",
        "upgrade_plan": "પ્લાન અપગ્રેડ કરો",
        "cancel_subscription": "સબ્સ્ક્રિપ્શન રદ કરો",
        "reactivate_subscription": "સબ્સ્ક્રિપ્શન ફરીથી સક્રિય કરો",
        "biling_info": "બિલિંગ માહિતી",
        "update_billing_info": "બિલિંગ માહિતી અપડેટ કરો",
        "contact_support": "સહાય માટે સંપર્ક કરો",
        "for_help_msg": "તમારા બિલિંગ પ્રશ્નો માટે મદદ અને સહાય માટે, અમારી સપોર્ટ ટીમનો સંપર્ક કરો અને તેઓ મદદ કરવા માટે ખુશ રહેશે.",
        "payment_methods": "ચુકવણી પદ્ધતિઓ",
        "update_payment_method": "ચુકવણી પદ્ધતિ અપડેટ કરો",
        "add_payment_method": "ચુકવણી પદ્ધતિ ઉમેરો",
        "ending_in": "અંતિમ",
        "payment_method_update": "ચુકવણી પદ્ધતિ સફળતાપૂર્વક અપડેટ.",
        "waiting_msg": "તમારી તાજેતરની ચુકવણી પદ્ધતિ અપડેટ તમારા આગામી બિલ સાથે અસરકારક થશે અને તમામ ભવિષ્યની ચુકવણી માટે ઉપયોગમાં લેવામાં આવશે.",
        "error_updating": "ચુકવણી પદ્ધતિ અપડેટ નિષ્ફળ. અમે તમારી ચુકવણી પદ્ધતિ અપડેટ કરતી વખતે સમસ્યા આવી. કૃપા કરીને ફરી પ્રયાસ કરો અથવા સહાય માટે સપોર્ટનો સંપર્ક કરો.",
        "card_expires": "કાર્ડની સમાપ્તિ તારીખ",
        "billing_address": "બિલિંગ સરનામું",
        "subscription_plan": "સબ્સ્ક્રિપ્શન પ્લાન",
        "next_renew_date": "આગામી નવીનીકરણ તારીખ",
        "storage_use": "સંગ્રહ ઉપયોગ",
        "address": "સરનામું",
        "address_line": "સરનામું લાઇન",
        "zip_code": "ઝિપ કોડ",
        "zip": "ઝિપ",
        "Save_&_Continue": "સાચવો અને ચાલુ રાખો",
        "billing_history": "બિલિંગ ઇતિહાસ",
        "Invoices": "ભરતિયાં",
        "credit_notes": "ક્રેડિટ નોટ્સ",
        "download": "ડાઉનલોડ",
        "id": "આઈડી",
        "type": "પ્રકાર",
        "date": "તારીખ",
        "description": "વર્ણન",
        "no_of_users": "વપરાશકર્તાઓની સંખ્યા",
        "amount": "રકમ",
        "status": "સ્થિતિ",
        "pay_now": "હવે ચૂકવો",
        "cancelling_subscription_message": "સબ્સ્ક્રિપ્શન રદ કરવાનો અર્થ છે કે તમારું સબ્સ્ક્રિપ્શન સમાપ્ત થાય છે",
        "reactivate_anytime": "ત્યાં પહેલાં કોઈપણ સમયે ફરીથી સક્રિય કરો!",
        "reactivate_confirmation": "શું તમે ખરેખર સબ્સ્ક્રિપ્શન ફરીથી સક્રિય કરવા માંગો છો? 'હા' પસંદ કરીને, તમે ફરીથી સક્રિય કરશો અને તમારી બિલિંગ શેડ્યૂલ ફરીથી શરૂ કરશો.",
        "amounting_to": "કુલ રકમ",
        "insufficient_funds": "અપર્યાપ્ત નાણાં",
        "payment_successful": "ચુકવણી સફળ.",
        "payment_successful_details": "ચુકવણી સફળ! તમારું ભરતિયું ચૂકવવામાં આવ્યું છે. કૃપા કરીને ફેરફારોને દરેક જગ્યાએ અસરકારક થવા માટે 2 થી 3 મિનિટની મંજૂરી આપો, ખાતરી કરો કે તમે વિસ્તૃત સુવિધાઓ અને સુધારાઓનો સંપૂર્ણ આનંદ માણી શકો!",
        "payment_unsuccessful": "ચુકવણી નિષ્ફળ. અમે તમારો પ્લાન અપગ્રેડ કરતી વખતે સમસ્યા આવી. કૃપા કરીને ફરી પ્રયાસ કરો અથવા સહાય માટે સપોર્ટનો સંપર્ક કરો.",
        "plan_upgrade_unsuccessful": "પ્લાન અપગ્રેડ નિષ્ફળ. અમે તમારો પ્લાન અપગ્રેડ કરતી વખતે સમસ્યા આવી. કૃપા કરીને ખાતરી કરો કે કાર્ડમાં પૂરતી બેલેન્સ છે.",
        "proceed_with_payment": "ભરતિયું નંબર માટે ચુકવણી ચાલુ રાખવા માંગો છો",
        "attention_needed": "તમારી ધ્યાન આપવાની જરૂર છે!",
        "avoid_service_disruption": "સેવા વિક્ષેપ ટાળવા માટે",
        "subscription_renewal_failed": "સબ્સ્ક્રિપ્શન ઓટો-નવીનીકરણ નિષ્ફળ થયું કારણ કે",
        "update_payment_method_please": "કૃપા કરીને તમારી ચુકવણી પદ્ધતિ અપડેટ કરો",
        "click_here_for_update_payment_method": "ચુકવણી પદ્ધતિ અપડેટ કરવા માટે અહીં ક્લિક કરો",
        "credit_balance": "ક્રેડિટ બેલેન્સ",
        "this_balance_will_be_used_for_a_future_payment": "આ બેલેન્સ ભવિષ્યની ચુકવણી માટે ઉપયોગમાં લેવામાં આવશે.",
        "paymnet_failed_subscription_canceled": "અમે તમને જાણ કરવા માંગીએ છીએ કે તમારી અગાઉની સબ્સ્ક્રિપ્શન રદ કરવામાં આવી છે. તમારું ખાતું હવે અમારી ડિફોલ્ટ સબ્સ્ક્રિપ્શન પર બદલવામાં આવ્યું છે, જેમાં કેટલીક સુવિધાઓ નિષ્ક્રિય કરવામાં આવી છે. આ સુવિધાઓને સક્રિય કરવા માટે, કૃપા કરીને તમારી યોજના અપગ્રેડ કરો.",
        "promotional_credit_balance": "પ્રચારાત્મક ક્રેડિટ",
        "balance": "બેલેન્સ",
        "created_on": "બનાવેલ છે",
        "no_promotional_found": "કોઈ પ્રમોશનલ ક્રેડિટ ઈતિહાસ મળ્યો નથી"
    },
    "Tour": {
        "tour_completed": "પ્રવાસ પૂર્ણ",
        "do_you_have_any": "શું તમારી પાસે કોઈ પ્રશ્નો છે? અમે તમને BRAND_NAME ના અમારા વ્યાપક વિડિઓ ટ્યુટોરિયલ્સને અન્વેષણ કરવા પ્રોત્સાહિત કરીએ છીએ જેથી પ્રારંભ કરી શકાય અને તમારા અનુભવનો સંપૂર્ણ લાભ લઈ શકાય.",
        "watch_video": "વિડિઓ જુઓ",
        "have_brief_tour_alianhub": "BRAND_NAME નો સંક્ષિપ્ત પ્રવાસ કરો?",
        "have_brief_tour_alianhub_view": "BRAND_NAME દૃશ્યોનો સંક્ષિપ્ત પ્રવાસ કરો?",
        "have_brief_tour_alianhub_left_side": "પ્રોજેક્ટ યાદીનો સંક્ષિપ્ત પ્રવાસ કરો?",
        "look_how_to_create": "પ્રોજેક્ટ કેવી રીતે બનાવવું, કાર્યો મેનેજ કરવું, સમય પત્રક અહેવાલો જોવું, ચેટમાં પ્રવેશ કરવો, ઉલ્લેખો અને સૂચનાઓ જોવી અને વધુ જુઓ.",
        "lets_start": "ચાલો શરૂ કરીએ",
        "no_thanks": "ના આભાર",
        "have_brief_task": "કાર્યનો સંક્ષિપ્ત પ્રવાસ કરો?",
        "have_brief_tour_project": "પ્રોજેક્ટનો સંક્ષિપ્ત પ્રવાસ કરો?",
        "look_how_to_create_task": "કાર્ય કેવી રીતે બનાવવું, કાર્ય મેનેજ કરવું, સ્થિતિ જૂથ અનુસાર કાર્ય જોવું અને વધુ જુઓ.",
        "look_how_to_create_project": "પ્રોજેક્ટ કેવી રીતે બનાવવું, પ્રોજેક્ટ મેનેજ કરવું, સ્થિતિ જૂથ અનુસાર કાર્ય જોવું અને વધુ જુઓ.",
        "project_creation_description": "પ્રોજેક્ટ્સને સરળતાથી બનાવવામાં, સોંપવામાં અને ટ્રૅક કરવામાં આવી શકે છે, ટીમ સભ્યો માટે જવાબદારીઓની સ્પષ્ટ દૃશ્યતા સાથે. આ વધુ સારી સંસ્થા પ્રોત્સાહિત કરે છે, જેમાં કાર્યક્ષમતા અને ઉત્પાદકતામાં સુધારો થાય છે. નવું પ્રોજેક્ટ શરૂ કરવા માટે અહીં ક્લિક કરો.",
        "enter_project_name": "તમારા પ્રોજેક્ટ માટે સંક્ષિપ્ત નામ દાખલ કરો.",
        "enter_project_key": "તમારા પ્રોજેક્ટ માટે સંક્ષિપ્ત કી દાખલ કરો.",
        "add_project_category": "તમારા પ્રોજેક્ટ માટે કેટેગરી ઉમેરો.",
        "enter_project_duedate": "તમારા પ્રોજેક્ટ માટે મર્યાદિત તારીખ દાખલ કરો.",
        "add_project_lead_assignee": "તમારા પ્રોજેક્ટ માટે લીડ અસાઇનિ ઉમેરો.",
        "create_project_from_template": "આ વિકલ્પ તમને અસ્તિત્વમાં રહેલા ટેમ્પલેટનો ઉપયોગ કરીને નવી પ્રોજેક્ટ ઝડપી રીતે બનાવવા દે છે, જે પૂર્વ-રૂપરેખિત ડેટા અને સેટિંગ્સ સાથે આવે છે, જેથી તમે આ જ પ્રોજેક્ટ ગોઠવણીને સરળતાથી પુનઃપ્રતિકૃતિ કરી શકો.",
        "customize_project_section": "આ વિકલ્પ તમને તમારા પ્રોજેક્ટને સંપૂર્ણ રીતે વૈયક્તિકૃત કરવાની મંજૂરી આપે છે, જેમ કે સ્થિતિઓ, પ્રકારો, એપ્લિકેશનો અને વધુ જેવા વિવિધ ઘટકોને તમારા વિશિષ્ટ જરૂરિયાતો મુજબ ગોઠવીને.",
        "task_type_templates_list_text": "ટાસ્ક પ્રકારના ટેમ્પલેટ્સની યાદી",
        "task_type_templates_description_text": "આ વિભાગ ઉપલબ્ધ ટાસ્ક પ્રકારના ટેમ્પલેટ્સ દર્શાવે છે. તમારા જરૂરિયાતોને અનુરૂપ એક પસંદ કરો.",
        "create_new_task_type_template_text": "નવો ટાસ્ક પ્રકારનો ટેમ્પલેટ બનાવો",
        "create_new_task_type_template_description_text": "નવો ટાસ્ક પ્રકારનો ટેમ્પલેટ ઉમેરવા માટે + બટન પર ક્લિક કરો, જેને તમે પછી તમારી ટાસ્ક માટે ઉપયોગમાં લઈ શકો છો.",
        "view_template_task_types_text": "ટેમ્પલેટના ટાસ્ક પ્રકાર જુઓ",
        "view_template_task_types_description_text": "અહિયાં તમે પસંદ કરેલા ટેમ્પલેટ સાથે જોડાયેલા ટાસ્ક પ્રકારોને જોઈ શકો છો. તમે તમારા જરૂરિયાતોને આધારે નવા ટાસ્ક પ્રકારો ફેરવી અથવા ઉમેરી શકો છો.",
        "add_new_task_type_text": "નવો ટાસ્ક પ્રકાર ઉમેરો",
        "add_new_task_type_description_text": "પસંદ કરેલા ટેમ્પલેટમાં નવા ટાસ્ક પ્રકારો શામેલ કરવા માટે 'ટાસ્ક પ્રકાર ઉમેરો' બટન પર ક્લિક કરો.",
        "save_project_as_template_text": "પ્રોજેક્ટને ટેમ્પલેટ તરીકે સાચવો",
        "save_project_as_template_description_text": "'ટેમ્પલેટ તરીકે સાચવો' પર ક્લિક કરીને વર્તમાન સેટઅપને ભવિષ્યના પ્રોજેક્ટ્સમાં વાપરવા માટે સાચવો.",
        "initiate_new_project_text": "નવો પ્રોજેક્ટ શરૂ કરો",
        "initiate_new_project_description_text": "નવું પ્રોજેક્ટ શરૂ કરવા માટે અહીં ક્લિક કરો.",
        "add_new_task_text": "નવો ટાસ્ક ઉમેરો",
        "input_task_name_text": "ટાસ્કનું નામ દાખલ કરો",
        "choose_task_status_text": "ટાસ્કની સ્થિતિ પસંદ કરો",
        "assign_task_text": "ટાસ્ક સોંપો",
        "set_task_deadline_text": "ટાસ્ક માટે સમય મર્યાદા નક્કી કરો",
        "define_task_priority_text": "ટાસ્કની પ્રાથમિકતા નક્કી કરો",
        "view_task_list_text": "ટાસ્ક યાદી જુઓ",
        "task_information_text": "ટાસ્ક માહિતી",
        "quick_task_menu_text": "ઝડપી ટાસ્ક મેનુ",
        "task_actions_text": "ટાસ્ક ક્રિયાઓ",
        "subtask_toggle_text": "સબટાસ્ક ટોગલ",
        "task_tour_complete_text": "ટાસ્ક ટૂર પૂર્ણ",
        "create_new_task_description_text": "'+ નવો ટાસ્ક' બટન પર ક્લિક કરીને નવો ટાસ્ક બનાવો.",
        "input_task_name_description_text": "પ્રદાન કરેલ ઇનપુટ ક્ષેત્રમાં ટાસ્કનું નામ દાખલ કરો.",
        "choose_task_status_description_text": "તમારી જરૂરિયાતોને અનુરૂપ યોગ્ય ટાસ્ક પ્રકાર પસંદ કરો.",
        "assign_task_description_text": "ટાસ્ક સોંપવાની વ્યક્તિ પસંદ કરો.",
        "set_task_deadline_description_text": "ટાસ્ક માટેની છેલ્લી તારીખ પસંદ કરો.",
        "define_task_priority_description_text": "ટાસ્ક માટે પ્રાથમિકતા સ્તર પસંદ કરો.",
        "view_task_list_description_text": "આ ટાસ્કની યાદી છે, જે તેમની વિગતો દર્શાવે છે અને સ્થિતિ દ્વારા જૂથિત છે.",
        "task_information_description_text": "અહિયાં પસંદ કરેલ ટાસ્કની વિગતો છે.",
        "quick_task_menu_description_text": "આઇકન પર ક્લિક કરવાથી ટાસ્ક ઓપરેશન વિકલ્પો સાથે ડ્રોપડાઉન મેનુ ખૂલશે.",
        "task_actions_description_text": "ઉપલબ્ધ ટાસ્ક ઓપરેશનોની યાદીમાંથી ક્રિયા પસંદ કરો.",
        "subtask_toggle_description_text": "સબટાસ્ક્સની યાદી દર્શાવવા માટે અહીં એક ટોગલ છે.",
        "task_tour_complete_description_text": "ટૂર પૂર્ણ થઇ છે. આગળની ઘણી શક્યતાઓ શોધવાનું શરૂ કરો!",
        "search_and_filter_projects_text": "પ્રોજેક્ટ્સ શોધો અને ફિલ્ટર કરો",
        "search_projects_text": "પ્રોજેક્ટ્સ શોધો",
        "search_options_for_projects_text": "પ્રોજેક્ટ્સ માટે શોધ વિકલ્પો",
        "search_projects_by_name_text": "નામ દ્વારા પ્રોજેક્ટ્સ શોધો",
        "advanced_project_search_text": "ઉન્નત પ્રોજેક્ટ શોધ",
        "filter_projects_by_favorites_text": "મનપસંદ દ્વારા પ્રોજેક્ટ્સ ફિલ્ટર કરો",
        "project_settings_text": "પ્રોજેક્ટ સેટિંગ્સ",
        "project_list_text": "પ્રોજેક્ટ યાદી",
        "end_of_project_view_tour_text": "પ્રોજેક્ટ દ્રશ્ય ટૂર પૂર્ણ",
        "search_and_filter_projects_description_text": "અહીં તમારી માપદંડો આધારિત પ્રોજેક્ટ્સ શોધો અને ફિલ્ટર કરો.",
        "enter_search_keywords_text": "ખાસ પ્રોજેક્ટ્સ શોધવા માટે શોધ કીવર્ડ્સ દાખલ કરો.",
        "search_filter_dropdown_description_text": "શોધ ફિલ્ટર સાથે ડ્રોપડાઉન મેનુ ખોલવા માટે આઇકન પર ક્લિક કરો.",
        "toggle_search_options_description_text": "ટાઈપ કરતી વખતે પ્રોજેક્ટ, સ્પ્રિન્ટ અથવા ફોલ્ડર દ્વારા શોધવા માટે વિકલ્પો વચ્ચે ટૉગલ કરો.",
        "advanced_search_icon_description_text": "ઉન્નત શોધ કામગીરી કરવા માટે આઇકન પર ક્લિક કરો.",
        "filter_by_favorites_description_text": "તમારા મનપસંદ પ્રોજેક્ટ્સને યાદીના ટોચ પર પ્રાથમિકતા આપવા માટે સ્ટાર આઇકન પર ક્લિક કરો.",
        "project_settings_icon_description_text": "આર્કાઇવ કરેલ અથવા અનઆર્કાઇવ કરેલ પ્રોજેક્ટ વિકલ્પો વચ્ચે સ્વિચ કરવા માટે સેટિંગ્સ આઇકન પર ક્લિક કરો.",
        "view_project_list_description_text": "અહિયાં તમે તમારી પ્રોજેક્ટ્સની યાદી જોઈ શકો છો.",
        "end_of_project_view_tour_description_text": "ટૂર હવે પૂર્ણ થયો છે.",
        "create_assign_prioritize_monitor_projects_text": "સહજતાથી પ્રોજેક્ટ્સ બનાવો, ફાળવો, પ્રાથમિકતા આપો અને મોનિટર કરો. ટીમના સભ્યોએ તેમની કાર્યો સ્પષ્ટપણે જોઈ શકે છે, ગોઠવણીમાં રહી શકે છે અને કાર્યક્ષમતા અને ઉત્પાદનક્ષમતા સુધારી શકે છે. નવો પ્રોજેક્ટ શરૂ કરવા માટે અહીં ક્લિક કરો.",
        "track_users_time_sheet_reports_text": "વપરાશકર્તાઓનો સમય વિવિધ સમય પત્રક રિપોર્ટ્સ જેમ કે વપરાશકર્તા સમય પત્રક, પ્રોજેક્ટ સમય પત્રક, કાર્યભાર સમય પત્રક અને ટ્રેકર સમય પત્રક સાથે અસરકારક રીતે ટ્રેક કરો. સમય પત્રક રિપોર્ટ્સ અન્વેષણ કરવા માટે અહીં ક્લિક કરો.",
        "user_time_sheet_description_text": "વપરાશકર્તા સમય પત્રક તમને તમારા વપરાશકર્તા ભૂમિકા મુજબ દરેક વપરાશકર્તા દ્વારા દાખલ કરેલા કલાકોની મોનીટરીંગ કરવાની મંજૂરી આપે છે.",
        "project_time_sheet_description_text": "તમારા વપરાશકર્તા ભૂમિકા આધારે પ્રોજેક્ટ સમય પત્રકમાં દરેક પ્રોજેક્ટ માટે નોંધાયેલા કલાકોને ટ્રેક કરો.",
        "workload_time_sheet_description_text": "વપરાશકર્તા સમય પત્રકની જેમ, કાર્યભાર સમય પત્રકમાં વપરાશકર્તાના કાર્યભાર, કુલ કલાકો અને અનુમાનિત કલાકોની વિગતો પણ શામેલ છે.",
        "tracker_sheet_description_text": "ટ્રેકર શીટ સમય ટ્રેકર દ્વારા નોંધાયેલ સમય, સ્ક્રીનશૉટ્સ અને કુલ ટ્રેક કરેલ સમય દર્શાવે છે.",
        "view_companies_switch_text": "તમારા સાથે સંકળાયેલી બધી કંપનીઓ જુઓ અને કોઈ એક પસંદ કરીને સરળતાથી કંપનીઓ વચ્ચે સ્વિચ કરો.",
        "engage_team_real_time_text": "ઝડપી નિર્ણય લેવા માટે રિયલ-ટાઇમમાં ટીમના સભ્યો સાથે જોડાઓ. ચેનલ્સ બનાવો અને જોડાણો, અવાજ સંદેશાઓ અને ટેક્સ્ટ દ્વારા માહિતી શેર કરો.",
        "real_time_notifications_text": "પ્રોજેક્ટ અને કાર્યની પ્રવૃત્તિઓ વિશે રિયલ-ટાઇમ સૂચનાઓ સાથે અપડેટ રહો, જેમાં કાર્ય ફાળવણી, સ્થિતિ ફેરફાર, ટિપ્પણીઓ અને સમયમર્યાદા શામેલ છે.",
        "address_specific_individuals_text": "પ્રોજેક્ટ મેનેજમેન્ટ સિસ્ટમમાં વિશિષ્ટ વ્યક્તિઓને સીધા સંબોધન કરો. કાર્યો, પ્રોજેક્ટ્સ અથવા ચર્ચાઓ સાથે સંબંધિત ઉલ્લેખ જુઓ.",
        "access_personal_information_text": "તમારા વપરાશકર્તા ભૂમિકા આધારે કંપનીઓ, પ્રોજેક્ટ્સ, વપરાશકર્તાઓ અને સુરક્ષાથી સંબંધિત સેટિંગ્સ સાથે તમારી વ્યક્તિગત માહિતીની ઍક્સેસ કરો.",
        "project_views_list_text": "પ્રોજેક્ટ દૃશ્યના યાદી",
        "add_new_project_view_text": "નવી પ્રોજેક્ટ દૃશ્ય ઉમેરો",
        "manage_project_views_text": "પ્રોજેક્ટ દૃશ્ય મેનેજ કરો",
        "project_files_text": "પ્રોજેક્ટ ફાઇલો",
        "project_audio_files_text": "પ્રોજેક્ટ ઓડિયો ફાઇલો",
        "add_project_watcher_text": "પ્રોજેક્ટ વોચર ઉમેરો",
        "project_operation_list_text": "પ્રોજેક્ટ ઓપરેશન યાદી",
        "advanced_task_filter_text": "અદ્યતન કાર્ય ફિલ્ટર",
        "search_tasks_text": "કાર્યો શોધો",
        "search_options_menu_text": "શોધ વિકલ્પો મેનુ",
        "search_criteria_text": "શોધ માપદંડ",
        "project_views_list_description_text": "ઉપલબ્ધ પ્રોજેક્ટ દૃશ્યની યાદી.",
        "add_new_project_view_description_text": "અહીં નવી દૃશ્ય બનાવો.",
        "manage_project_views_description_text": "અહીં તમે પ્રોજેક્ટ માટે દૃશ્ય ઉમેરી શકો અથવા પિન કરી શકો છો. દૃશ્ય ઉમેરવા માટે 'વ્યુ ઉમેરો' ક્લિક કરો અથવા પિન કરવા માટે 'વ્યુ પિન' પસંદ કરો.",
        "project_files_description_text": "આઈકન પર ક્લિક કરીને તમામ પ્રોજેક્ટ ફાઇલો અને લિંક્સ ઍક્સેસ કરો.",
        "project_audio_files_description_text": "પ્રોજેક્ટ સંબંધિત તમામ ઓડિયો ફાઇલો જોવા માટે આઈકન પર ક્લિક કરો.",
        "add_project_watcher_description_text": "તમારા પ્રોજેક્ટ વોચર સેટિંગ્સ મેનેજ કરો.",
        "project_operation_list_description_text": "અહીંથી વિવિધ પ્રોજેક્ટ ઓપરેશનો કરો.",
        "advanced_task_filter_description_text": "અદ્યતન શોધ માટે આઈકન પર ક્લિક કરો.",
        "search_tasks_description_text": "વિશિષ્ટ કાર્યો માટે શોધવા માટે સંબંધિત કીવર્ડ્સ દાખલ કરો.",
        "search_options_menu_description_text": "વિભિન્ન શોધ વિકલ્પો સાથે ડ્રોપડાઉન ખોલવા માટે આઈકન પર ક્લિક કરો.",
        "search_criteria_description_text": "લખતાં જ શોધ સુધારવા માટે કાર્યનું નામ, કાર્ય કી, અથવા વર્ણનમાંથી પસંદ કરો.",
        "select_operation_description_text": "પ્રોજેક્ટ પર ઇચ્છિત ક્રિયા કરવાનો हेतु યાદીમાંથી ક્રિયા પસંદ કરો."
    },
    "TaskStatus": {
        "To_Do": "કરવાનું"
    },
    "AI": {
        "generate": "ઉત્પાદિત કરો",
        "ai_button": "AI સાથે લખો",
        "ai_title": "AI ને કંઈપણ શોધવા અથવા બનાવવા માટે પૂછો",
        "write_with_ai": "AI સાથે લખો",
        "suggest_tasks": "કાર્યો સૂચવો",
        "suggest_subtasks": "ઉપકાર્યો સૂચવો",
        "ai_sidebar_placeholder": "તમે AI ને શું લખવા માંગો છો?",
        "ai_chat_placeholder": "AI ને આગળ શું કરવું તે કહો",
        "ai_available_on_paid_plans_upgrade_now": "AI માત્ર અમારા ચૂકવેલ પ્લાન પર ખરીદવા માટે ઉપલબ્ધ છે. અપગ્રેડ કરો અને હવે AI ઉમેરો!",
        "please_upgrade_plan_to_use_ai": "AI નો ઉપયોગ કરવા માટે કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો.",
        "read_less": "ઓછું વાંચો",
        "read_more": "વધુ વાંચો",
        "to_unlock_ai": "AI અનલૉક કરવા માટે",
        "copy": "નકલ કરો",
        "generating_results": "પરિણામો ઉત્પન્ન કરી રહ્યા છે",
        "hub_ai": "HubAi",
        "regenerate": "ફરીથી ઉત્પન્ન કરો",
        "title": "શીર્ષક",
        "error_occurred_engine_issue": "એક ભૂલ આવી. અથવા તો તમે જે એન્જિનની વિનંતી કરી છે તે અસ્તિત્વમાં નથી અથવા તમારી વિનંતી પ્રક્રિયા કરતી વખતે બીજી સમસ્યા હતી",
        "ai_not_integrated": "AI તમારા સિસ્ટમમાં એકીકૃત નથી",
        "limit_reached": "તમે તમારી મર્યાદા પર પહોંચી ગયા છો"
    },
    "Toast": {
        "Your_card_is_expired": "તમારું કાર્ડ સમયમર્યાદા પૂરી થઈ ગયું છે.",
        "Password_set_new_has_been_successfully": "નવો પાસવર્ડ સફળતાપૂર્વક સેટ કરવામાં આવ્યો છે.",
        "task_created_successfully": "કાર્ય સફળતાપૂર્વક બનાવવામાં આવ્યું",
        "please_remove_the_advanced_filter_to_view_newly_created_projects": ", નવા બનાવેલા પ્રોજેક્ટ જોવા માટે કૃપા કરીને એડવાન્સ ફિલ્ટર દૂર કરો.",
        "create_task_plan_limit_message": "તમારો પ્લાન અપગ્રેડ કરો. તમે TASK_SPRINT સ્પ્રિન્ટમાં કાર્યો બનાવવા માટે મર્યાદા પર પહોંચી ગયા છો.",
        "something_went_wrong": "કંઈક ખોટું થયું.",
        "file_size_is_larger_than_maxFileSize": "ફાઇલ કદ maxFileSize કરતાં મોટું છે",
        "Select_image_only_and_image_file_format_should_be_FILE_FORMATS": "માત્ર છબી પસંદ કરો અને છબી ફાઇલ ફોર્મેટ FILE_FORMATS હોવું જોઈએ",
        "Select_file_only_image_and_image_file_format_should_be_FILE_FORMATS": "માત્ર ફાઇલ છબી પસંદ કરો અને છબી ફાઇલ ફોર્મેટ FILE_FORMATS હોવું જોઈએ",
        "Multiple_files_not_allowed": "એકથી વધુ ફાઇલો મંજૂર નથી.",
        "Please_select_valid_file": "કૃપા કરીને માન્ય ફાઇલ પસંદ કરો.",
        "require_image_format_message": "ફાઇલ ફોર્મેટ સપોર્ટ થયેલ નથી અથવા કંપની સેટિંગ્સમાં ઉમેરવામાં આવેલ નથી. તમે સેટિંગ્સમાં ફાઇલ ફોર્મેટ ઉમેરી શકો છો.",
        "You_have_to_add_extension_in_setting": "તમારે સેટિંગમાં એક્સટેન્શન ઉમેરવું પડશે.",
        "Something_went_wrong_Please_try_again": "કંઈક ખોટું થયું. કૃપા કરીને ફરી પ્રયાસ કરો.",
        "Company_is_disable": "કંપની અક્ષમ છે",
        "advance_search_feature_upgrade_message": "આ સુવિધા એડવાન્સ સર્ચ તમારા વર્તમાન પ્લાન પર ઉપલબ્ધ નથી. એડવાન્સ સર્ચ અનલૉક કરવા માટે તમારો પ્લાન અપગ્રેડ કરો.",
        "Access_Denied": "પ્રવેશ નકારી દેવામાં આવ્યો",
        "notification_permission": "સૂચનાઓ પ્રાપ્ત કરવા માટે, કૃપા કરીને સાઇટ સેટિંગ્સમાં સૂચના પરવાનગીની મંજૂરી આપો અને પાનું ફરીથી લોડ કરો.",
        "Link_is_Copied_to_clipboard": "લિંક ક્લિપબોર્ડ પર નકલ કરવામાં આવી છે",
        "Task_Key_is_Copied_to_clipboard": "કાર્ય કી ક્લિપબોર્ડ પર નકલ કરવામાં આવી છે",
        "At_least_one_field_is_required": "ઓછામાં ઓછું એક ફીલ્ડ જરૂરી છે.",
        "Task_name_updated_successfully": "કાર્ય નામ સફળતાપૂર્વક અપડેટ થયું",
        "Watcher_added_successfully": "વોચર સફળતાપૂર્વક ઉમેરાયો",
        "Watcher_removed_successfully": "વોચર સફળતાપૂર્વક દૂર થયો",
        "Nothing_to_update": "અપડેટ કરવા માટે કંઈ નથી",
        "Sprint created successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક બનાવવામાં આવ્યો",
        "Sprint restored successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક પુનઃસ્થાપિત થયો",
        "Sprint closed successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક બંધ થયો",
        "Sprint archived successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક આર્કાઇવ થયો",
        "Sprint deleted successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક કાઢી નાખ્યો",
        "Upgrade_your_plan_you_have_reached_the_limit_for_creating_sprints": "તમારો પ્લાન અપગ્રેડ કરો. તમે સ્પ્રિન્ટ્સ બનાવવા માટે મર્યાદા પર પહોંચી ગયા છો.",
        "Folder created successfully": "ફોલ્ડર સફળતાપૂર્વક બનાવવામાં આવ્યું",
        "Folder updated successfully": "ફોલ્ડર સફળતાપૂર્વક અપડેટ થયું",
        "Folde restored successfully": "ફોલ્ડર સફળતાપૂર્વક પુનઃસ્થાપિત થયું",
        "Folder closed successfully": "ફોલ્ડર સફળતાપૂર્વક બંધ થયું",
        "Folder archived successfully": "ફોલ્ડર સફળતાપૂર્વક આર્કાઇવ થયું",
        "Folder deleted successfully": "ફોલ્ડર સફળતાપૂર્વક કાઢી નાખ્યું",
        "Status_changed_successfully": "સ્થિતિ સફળતાપૂર્વક બદલાઈ",
        "Due_date_updated_successfully": "નિયત તારીખ સફળતાપૂર્વક અપડેટ થઈ",
        "Due_date_not_updated": "નિયત તારીખ અપડેટ થઈ નથી",
        "Assignee changed_ uccessfully": "સોંપનાર સફળતાપૂર્વક બદલાયો",
        "Assignee added successfully": "સોંપનાર સફળતાપૂર્વક ઉમેરાયો",
        "Assignee removed successfully": "સોંપનાર સફળતાપૂર્વક દૂર થયો",
        "Assignee not updated": "સોંપનાર અપડેટ થયો નથી",
        "Task_updated_successfully": "કાર્ય સફળતાપૂર્વક અપડેટ થયું",
        "Task_restored_successfully": "કાર્ય સફળતાપૂર્વક પુનઃસ્થાપિત થયું",
        "Task_archived_successfully": "કાર્ય સફળતાપૂર્વક આર્કાઇવ થયું",
        "Task_deleted_successfully": "કાર્ય સફળતાપૂર્વક કાઢી નાખ્યું",
        "Tag_Deleted_successfully": "ટૅગ સફળતાપૂર્વક કાઢી નાખ્યો",
        "Log_time_added_successfully": "લૉગ સમય સફળતાપૂર્વક ઉમેરાયો.",
        "Filter_saved_successfully": "ફિલ્ટર સફળતાપૂર્વક સાચવ્યું.",
        "Filter_update_successfully": "ફિલ્ટર સફળતાપૂર્વક અપડેટ થયું.",
        "Filter_deleted_successfully": "ફિલ્ટર સફળતાપૂર્વક કાઢી નાખ્યું.",
        "Checklist_creted_succesfully.": "ચેકલિસ્ટ સફળતાપૂર્વક બનાવવામાં આવ્યું.",
        "Please_select_checklist": "કૃપા કરીને ચેકલિસ્ટ પસંદ કરો.",
        "already_exists": "EXIST_VALUE પહેલેથી જ અસ્તિત્વમાં છે",
        "Converted_sucessfully": "સફળતાપૂર્વક રૂપાંતરિત થયું",
        "create_task_limit_in_sprint_upgrade_task_message": "તમારો પ્લાન અપગ્રેડ કરો. તમે SELECTED_SPRINT_DATA સ્પ્રિન્ટમાં કાર્યો બનાવવા માટે મર્યાદા પર પહોંચી ગયા છો.",
        "Please_Select_Task_Type": "કૃપા કરીને કાર્ય પ્રકાર પસંદ કરો",
        "Please_Select_Task": "કૃપા કરીને કાર્ય પસંદ કરો",
        "Task_moved_sucessfully": "કાર્ય સફળતાપૂર્વક ખસેડાયું",
        "Task_not_moved": "કાર્ય ખસેડાયું નથી",
        "Task_duplicate_sucessfully": "કાર્ય સફળતાપૂર્વક નકલ થયું",
        "Task_not_duplicated": "કાર્ય નકલ થયું નથી",
        "Convert_in_to_task_sucessfully": "સફળતાપૂર્વક કાર્યમાં રૂપાંતરિત કરો",
        "Company_name_already_exists": "કંપની નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "Company_has_been_created_Successfully": "કંપની સફળતાપૂર્વક બનાવવામાં આવી છે.",
        "Custom_field_updated_successfully": "કસ્ટમ ફીલ્ડ સફળતાપૂર્વક અપડેટ થયું",
        "No_assignee_found": "કોઈ સોંપનાર મળ્યો નથી",
        "No_due_date_found": "કોઈ નિયત તારીખ મળી નથી",
        "No_self_assignee_found": "કોઈ સ્વ-સોંપનાર મળ્યો નથી",
        "Estimated_time_updated_successfully": "અંદાજિત સમય સફળતાપૂર્વક અપડેટ થયો",
        "Description_updated_successfully": "વર્ણન સફળતાપૂર્વક અપડેટ થયું",
        "Description_not_updated": "વર્ણન અપડેટ થયું નથી",
        "Copied": "નકલ થયું!",
        "User_removed_successfully": "વપરાશકર્તા સફળતાપૂર્વક દૂર થયો",
        "Invitation_cancelled_successfully": "આમંત્રણ સફળતાપૂર્વક રદ થયું",
        "User_role_changed_successfully": "વપરાશકર્તાની ભૂમિકા સફળતાપૂર્વક બદલાઈ",
        "User_designation_changed_successfully": "વપરાશકર્તાની નિમણૂક સફળતાપૂર્વક બદલાઈ.",
        "Please_upgrade_your_plan_to_use_Time_Tracker": "ટાઇમ ટ્રેકરનો ઉપયોગ કરવા માટે કૃપા કરીને તમારો પ્લાન અપગ્રેડ કરો.",
        "Request_remove_successfully": "વિનંતી સફળતાપૂર્વક દૂર થઈ",
        "Upgrade_Your_Plan": "તમારો પ્લાન અપગ્રેડ કરો",
        "Updated_successfully": "સફળતાપૂર્વક અપડેટ થયું",
        "Deleted_successfully": "સફળતાપૂર્વક કાઢી નાખ્યું",
        "View_Pinned": "પિન કરેલું જુઓ",
        "View_Unpinned": "અનપિન કરેલું જુઓ",
        "View_Already_Added": "પહેલેથી જ ઉમેરેલું જુઓ",
        "Company_details_saved_successfully": "કંપનીની વિગતો સફળતાપૂર્વક સેવ થઈ ગઈ છે.",
        "Currency_added_successfully": "કરન્સી સફળતાપૂર્વક ઉમેરાઈ",
        "Currency_removed_successfully": "કરન્સી સફળતાપૂર્વક દૂર થઈ",
        "File_extension_remove_successfully": "ફાઇલ એક્સ્ટેન્શન FILE_EXTENSION સફળતાપૂર્વક દૂર કરવામાં આવ્યું",
        "File_extension_update_successfully": "ફાઇલ એક્સટેન્શન સફળતાપૂર્વક અપડેટ થયું.",
        "Status_updated_successfully": "સ્થિતિ સફળતાપૂર્વક અપડેટ થઈ",
        "Project_milestone_status_Deleted_successfully": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ સફળતાપૂર્વક કાઢી નાખી.",
        "Milestone_weekly_range_updated_successfully": "માઇલસ્ટોન સાપ્તાહિક શ્રેણી સફળતાપૂર્વક અપડેટ થઈ.",
        "Image_dimensions_should_not_exceed_ImageDimensions_pixels": "છબીના પરિમાણો ImageDimensions પિક્સેલ્સ કરતાં વધુ ન હોવા જોઈએ.",
        "error_in_uploading_image_please_try_it_again": "છબી અપલોડ કરવામાં ભૂલ, કૃપા કરીને ફરી પ્રયાસ કરો",
        "Task_priority_updated_successfully": "કાર્ય પ્રાથમિકતા સફળતાપૂર્વક અપડેટ થઈ.",
        "Task_priority_Remove_successfully": "કાર્ય પ્રાથમિકતા સફળતાપૂર્વક દૂર થઈ.",
        "Priority_updated_successfully": "પ્રાથમિકતા સફળતાપૂર્વક અપડેટ થઈ",
        "Priority_not_updated": "પ્રાથમિકતા અપડેટ થઈ નથી",
        "error_in_deleting_priority_please_try_it_again": "પ્રાથમિકતા કાઢી નાખવામાં ભૂલ, કૃપા કરીને ફરી પ્રયાસ કરો",
        "Field_Enable_Successfully": "ફીલ્ડ સફળતાપૂર્વક સક્રિય",
        "Field_Disable_Successfully": "ફીલ્ડ સફળતાપૂર્વક અક્ષમ",
        "Field_Added_Successfully": "ફીલ્ડ સફળતાપૂર્વક ઉમેરાઈ",
        "Field_Updated_Successfully": "ફીલ્ડ સફળતાપૂર્વક અપડેટ થઈ",
        "Added_to_favourite": "મનપસંદમાં ઉમેર્યું",
        "Removed_from_favourite": "મનપસંદમાંથી દૂર કર્યું",
        "Tag_Created_successfully": "ટૅગ સફળતાપૂર્વક બનાવવામાં આવ્યું",
        "Queue list added successfully": "કતાર યાદી સફળતાપૂર્વક ઉમેરાઈ",
        "Queue list removed successfully": "કતાર યાદી સફળતાપૂર્વક દૂર થઈ",
        "Queue list not updated": "કતાર યાદી અપડેટ થઈ નથી",
        "Attachments_uploaded_successfully": "જોડાણો સફળતાપૂર્વક અપલોડ થયા",
        "Attachment_removed_successfully": "જોડાણ સફળતાપૂર્વક દૂર થયું",
        "Attachment_not_removed": "જોડાણ દૂર થયું નથી",
        "Please_try_again": "કૃપા કરીને ફરી પ્રયાસ કરો",
        "Task_name_copied": "કાર્ય નામ નકલ થયું",
        "Status_already_exists": "સ્થિતિ પહેલેથી જ અસ્તિત્વમાં છે",
        "Status_added_sucessfully": "સ્થિતિ સફળતાપૂર્વક ઉમેરાઈ",
        "Task_Type_already_exists": "કાર્ય પ્રકાર પહેલેથી જ અસ્તિત્વમાં છે",
        "Task_Type_added_sucessfully": "કાર્ય પ્રકાર સફળતાપૂર્વક ઉમેરાયો",
        "Image_size_must_be_less_than_ImageDimensions_pixels": "છબીનું કદ ImageDimensions પિક્સેલ્સ કરતાં ઓછું હોવું જોઈએ.",
        "Data_deleted_successfully": "ડેટા સફળતાપૂર્વક કાઢી નાખ્યો.",
        "Category_created_successfully": "કેટેગરી સફળતાપૂર્વક બનાવવામાં આવી",
        "Please_select_an_image_file": "કૃપા કરીને છબી ફાઇલ પસંદ કરો",
        "Channel_created_successfully": "ચેનલ સફળતાપૂર્વક બનાવવામાં આવી",
        "Folder_not_found": "ફોલ્ડર મળ્યું નથી",
        "Template_&_Project_data_has_been_added_successfully": "ટેમ્પલેટ અને પ્રોજેક્ટ ડેટા સફળતાપૂર્વક ઉમેરવામાં આવ્યા છે.",
        "Project_data_has_been_added_successfully": "પ્રોજેક્ટ ડેટા સફળતાપૂર્વક ઉમેરવામાં આવ્યા છે{filterMessage}",
        "Error_in_creating_project": "પ્રોજેક્ટ બનાવવામાં ભૂલ",
        "Milestone_deleted_successfully": "માઇલસ્ટોન સફળતાપૂર્વક કાઢી નાખ્યો",
        "Error_in_deleting_milestone": "માઇલસ્ટોન કાઢી નાખવામાં ભૂલ",
        "Milestone_added_successfully": "માઇલસ્ટોન સફળતાપૂર્વક ઉમેરાયો",
        "Error_in_adding_milestone": "માઇલસ્ટોન ઉમેરવામાં ભૂલ",
        "Milestone_update_successfully": "માઇલસ્ટોન સફળતાપૂર્વક અપડેટ થયો",
        "Error_in_updating_milestone": "માઇલસ્ટોન અપડેટ કરવામાં ભૂલ",
        "Milestone_status_update_successfully": "માઇલસ્ટોન સ્થિતિ સફળતાપૂર્વક અપડેટ થઈ",
        "Error_in_updating_milestone_status": "માઇલસ્ટોન સ્થિતિ અપડેટ કરવામાં ભૂલ",
        "Milestone_refund_amount_update_successfully": "માઇલસ્ટોન રિફંડ રકમ સફળતાપૂર્વક અપડેટ થઈ",
        "Error_in_updating_milestone_refund_amount": "માઇલસ્ટોન રિફંડ રકમ અપડેટ કરવામાં ભૂલ",
        "The_project_not_found": "પ્રોજેક્ટ મળ્યો નથી.",
        "The_project_is_archived": "પ્રોજેક્ટ આર્કાઇવ છે.",
        "Start_date_of_project_should_be_smaller_than_current_date": "પ્રોજેક્ટની પ્રારંભ તારીખ વર્તમાન તારીખ કરતાં નાની હોવી જોઈએ",
        "All_the_range_is_included_in_milestone": "બધા શ્રેણી માઇલસ્ટોનમાં સમાવેશ થાય છે",
        "Please_enter_start_date_of_project": "કૃપા કરીને પ્રોજેક્ટની પ્રારંભ તારીખ દાખલ કરો",
        "Project_name_updated_successfully": "પ્રોજેક્ટ નામ સફળતાપૂર્વક અપડેટ થયું",
        "Project restored successfully": "પ્રોજેક્ટ સફળતાપૂર્વક પુનઃસ્થાપિત થયું",
        "Project closed successfully": "પ્રોજેક્ટ સફળતાપૂર્વક બંધ થયું",
        "Project archived successfully": "પ્રોજેક્ટ સફળતાપૂર્વક આર્કાઇવ થયું",
        "Project deleted successfully": "પ્રોજેક્ટ સફળતાપૂર્વક કાઢી નાખ્યું",
        "Enter_valid_project_source": "માન્ય પ્રોજેક્ટ સ્રોત દાખલ કરો",
        "Please_select_sub_task": "કૃપા કરીને ઉપકાર્ય પસંદ કરો.",
        "Status_not_updated": "સ્થિતિ અપડેટ થઈ નથી",
        "Start_date_updated_successfully": "પ્રારંભ તારીખ સફળતાપૂર્વક અપડેટ થઈ",
        "Start_date_not_updated": "પ્રારંભ તારીખ અપડેટ થઈ નથી",
        "Task_converted_sucessfully": "કાર્ય સફળતાપૂર્વક રૂપાંતરિત થયું",
        "Task_merged_sucessfully": "કાર્ય સફળતાપૂર્વક મર્જ થયું",
        "Can_not_create_template_name_Custom": "કસ્ટમ નામ સાથે ટેમ્પલેટ બનાવી શકતા નથી",
        "Template_name_updated_successfully": "ટેમ્પલેટ નામ સફળતાપૂર્વક અપડેટ થયું.",
        "Template_has_been_created_Successfully": "ટેમ્પલેટ સફળતાપૂર્વક બનાવવામાં આવ્યું છે.",
        "Template_deleted_successfull": "ટેમ્પલેટ સફળતાપૂર્વક કાઢી નાખ્યું.",
        "Template_has_been_deleted_successfully": "ટેમ્પલેટ સફળતાપૂર્વક કાઢી નાખ્યું છે.",
        "Storage_exceeded_Upgrade_your_plan": "સંગ્રહ મર્યાદા વટાવી. તમારો પ્લાન અપગ્રેડ કરો",
        "max_filesize_messages": "મહત્તમ ફાઇલ કદ FILE_SIZE MB છે.",
        "Password_reset_email_has_been_sent_successfully": "પાસવર્ડ રીસેટ ઇમેલ સફળતાપૂર્વક મોકલવામાં આવ્યો છે",
        "Invalid_username_or_password": "અમાન્ય વપરાશકર્તા નામ અથવા પાસવર્ડ.",
        "Email_Not_Verified": "ઇમેલ ચકાસાયેલ નથી.",
        "Verification_mail_has_been_send_successfully": "ચકાસણી મેલ સફળતાપૂર્વક મોકલવામાં આવ્યો છે",
        "Invalid_url": "અમાન્ય URL",
        "User_already_registered": "વપરાશકર્તા પહેલેથી જ નોંધાયેલ છે.",
        "User_has_been_registered_successfully": "વપરાશકર્તા સફળતાપૂર્વક નોંધાયેલ છે.",
        "The_email_address_is_already_in_use": "ઇમેલ સરનામું પહેલેથી જ ઉપયોગમાં છે",
        "User_has_been_registered_successfully_Please_verify_your_email_to_continue": "વપરાશકર્તા સફળતાપૂર્વક નોંધાયેલ છે, કૃપા કરીને ચાલુ રાખવા માટે તમારું ઇમેલ ચકાસો.",
        "Password_reset_has_been_successfully": "પાસવર્ડ રીસેટ સફળતાપૂર્વક થયું છે",
        "Your_email_has_been_verify_successfully": "તમારું ઇમેલ સફળતાપૂર્વક ચકાસવામાં આવ્યું છે",
        "Invitation_accepted_successfully": "આમંત્રણ સફળતાપૂર્વક સ્વીકાર્યું",
        "Only_product_owner_can_create_a_company": "ફક્ત ઉત્પાદન માલિક જ કંપની બનાવી શકે છે",
        "Company_name_must_be_unique": "કંપની નામ અનન્ય હોવું જોઈએ.",
        "Subscription_cancel_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "સબ્સ્ક્રિપ્શન સફળતાપૂર્વક રદ થયું. કૃપા કરીને ફેરફારોને દરેક જગ્યાએ અસરકારક થવા માટે 2 થી 3 મિનિટની મંજૂરી આપો.",
        "Subscription_reactivate_succesfully_Please_allow_2_to_3_minutes_for_the_changes_to_take_effect_everywhere": "સબ્સ્ક્રિપ્શન સફળતાપૂર્વક ફરીથી સક્રિય થયું. કૃપા કરીને ફેરફારોને દરેક જગ્યાએ અસરકારક થવા માટે 2 થી 3 મિનિટની મંજૂરી આપો.",
        "View_name_is_required": "દૃશ્ય નામ જરૂરી છે",
        "name_should_be_at_least_3_characters_long": "નામ ઓછામાં ઓછું 3 અક્ષરો લાંબું હોવું જોઈએ",
        "View_name_already_exists": "દૃશ્ય નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "View_added_successfully": "દૃશ્ય સફળતાપૂર્વક ઉમેર્યું",
        "View_Deleted_Successfully": "દૃશ્ય સફળતાપૂર્વક કાઢી નાખ્યું",
        "Link_copied_to_clipboard_successfully": "લિંક સફળતાપૂર્વક ક્લિપબોર્ડ પર નકલ કરી",
        "Project_avatar_updated_successfully": "પ્રોજેક્ટ અવતાર સફળતાપૂર્વક અપડેટ થયો",
        "Message pinned successfully": "સંદેશ સફળતાપૂર્વક પિન થયો",
        "Message unpinned successfully": "સંદેશ સફળતાપૂર્વક અનપિન થયો",
        "Message_copied": "સંદેશ નકલ થયો",
        "Item_cannot_be_empty": "આઇટમ ખાલી ન હોઈ શકે",
        "Maximum_MAX_CHAR_characters_are_allowed": "મહત્તમ MAX_CHAR અક્ષરો મંજૂર છે",
        "Item_added_to_checklist": "આઇટમ ચેકલિસ્ટમાં ઉમેર્યું",
        "Maximum_10_files_can_be_uploaded_at_once": "એક સાથે મહત્તમ 10 ફાઇલો અપલોડ કરી શકાય છે",
        "file_type_is_not_supported": "ફાઇલ પ્રકાર સપોર્ટેડ નથી!",
        "ERROR_in_file_upload": "ફાઇલ અપલોડમાં ભૂલ",
        "file_size_is_larger_than_FILE_SIZE_mb": "ફાઇલ કદ FILE_SIZE mb કરતાં મોટું છે!",
        "Mark_as_favorite_successfully": "સફળતાપૂર્વક મનપસંદ તરીકે ચિહ્નિત કરો",
        "Start_and_Due_date_updated_successfully": "પ્રારંભ અને નિયત તારીખ સફળતાપૂર્વક અપડેટ થઈ",
        "Start_and_Due_date_not_updated": "પ્રારંભ અને નિયત તારીખ અપડેટ થઈ નથી",
        "Attchments_deleted_successfully": "જોડાણો સફળતાપૂર્વક કાઢી નાખ્યા",
        "Designation_is_required": "હોદ્દો જરૂરી છે",
        "Designation_already_exists": "હોદ્દો પહેલેથી જ અસ્તિત્વમાં છે",
        "Designation_added_successfully": "હોદ્દો સફળતાપૂર્વક ઉમેર્યો",
        "Designation_updated_successfully": "હોદ્દો સફળતાપૂર્વક અપડેટ થયો",
        "Role_is_required": "ભૂમિકા જરૂરી છે",
        "Role_already_exists": "ભૂમિકા પહેલેથી જ અસ્તિત્વમાં છે",
        "Role_added_successfully": "ભૂમિકા સફળતાપૂર્વક ઉમેરાઈ",
        "Role_updated_successfully": "ભૂમિકા સફળતાપૂર્વક અપડેટ થઈ",
        "Please_provide_an_email_id": "કૃપા કરીને ઇમેલ આઈડી આપો",
        "Please_provide_a_designation": "કૃપા કરીને હોદ્દો આપો",
        "Please_provide_a_role": "કૃપા કરીને ભૂમિકા આપો",
        "Designation_deleted_successfully": "હોદ્દો સફળતાપૂર્વક કાઢી નાખ્યો",
        "The_role_is_already_in_use_so_it_can't_be_deleted": "ભૂમિકા પહેલેથી જ ઉપયોગમાં છે, તેથી તેને કાઢી શકાતું નથી.",
        "Role_deleted_successfully": "ભૂમિકા સફળતાપૂર્વક કાઢી નાખી",
        "Language_not_updated": "ભાષા અપડેટ થઈ નથી!",
        "Profile_updated_successfully": "પ્રોફાઇલ સફળતાપૂર્વક અપડેટ થયું.",
        "Notification_Settings_Update_successfully": "સૂચના સેટિંગ્સ સફળતાપૂર્વક અપડેટ",
        "Permission_updated_successfully": "પરવાનગી સફળતાપૂર્વક અપડેટ થઈ",
        "Per_User_Generate_Limit_value_is_not_valid": "પ્રતિ વપરાશકર્તા જનરેટ મર્યાદા મૂલ્ય માન્ય નથી",
        "Team_name_is_required": "ટીમ નામ જરૂરી છે",
        "Minimum_3_character_required": "ઓછામાં ઓછા 3 અક્ષરો જરૂરી છે",
        "Team_name_already_exist": "ટીમ નામ પહેલેથી જ અસ્તિત્વમાં છે",
        "Template_has_been_added_successfully": "ટેમ્પલેટ સફળતાપૂર્વક ઉમેરાયું છે.",
        "Billing_details_has_been_updated_successfully": "બિલિંગ વિગતો સફળતાપૂર્વક અપડેટ થઈ છે",
        "Billing_details_not_updated": "બિલિંગ વિગતો અપડેટ થઈ નથી",
        "Invalid_Card_Details_Please_check_and_try_again": "અમાન્ય કાર્ડ વિગતો. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો.",
        "Expired_Card_Please_check_and_try_again": "સમાપ્ત થયેલ કાર્ડ. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો.",
        "Invalid_card_verification_code_(CVC)_Please_check_and_try_again": "અમાન્ય કાર્ડ ચકાસણી કોડ (CVC). કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો.",
        "You_have_cancel_your_current_subscription_at_term_end_please_reactivate_subscription_and_try_again": "તમે તમારી વર્તમાન સબ્સ્ક્રિપ્શન અવધિના અંતે રદ કરી છે કૃપા કરીને સબ્સ્ક્રિપ્શન ફરીથી સક્રિય કરો અને ફરી પ્રયાસ કરો.",
        "Plan_not_purchased_Please_try_again": "પ્લાન ખરીદ્યો નથી. કૃપા કરીને ફરી પ્રયાસ કરો.",
        "Please_fill_out_billing_details_first": "કૃપા કરીને પહેલા બિલિંગ વિગતો ભરો.",
        "Please_check_your_credential": "કૃપા કરીને તમારી ઓળખ તપાસો.",
        "File_type_not_supported": "ફાઇલ પ્રકાર સપોર્ટેડ નથી",
        "Are_you_sure_to_delete_this_file": "શું તમે ખરેખર આ ફાઇલ કાઢી નાખવા માંગો છો?",
        "Select_Project_Type": "પ્રોજેક્ટ પ્રકાર પસંદ કરો",
        "Tracker_user_added_successfully": "ટ્રેકર વપરાશકર્તા સફળતાપૂર્વક ઉમેરાયો",
        "Tracker_user_removed_successfully": "ટ્રેકર વપરાશકર્તા સફળતાપૂર્વક દૂર થયો",
        "queue_list_not_updated": "કતાર યાદી અપડેટ થઈ નથી.",
        "upgrade_plan_folder_limit_reached": "તમારો પ્લાન અપગ્રેડ કરો. તમે ફોલ્ડર્સ બનાવવા માટે મર્યાદા પર પહોંચી ગયા છો",
        "View_updated_successfully": "દૃશ્ય સફળતાપૂર્વક અપડેટ થયું",
        "The_designation_is_already_in_use_so_it_cant_be_deleted": "હોદ્દો પહેલેથી જ ઉપયોગમાં છે, તેથી તેને કાઢી શકાતું નથી",
        "Sprint_already_exists": "સ્પ્રિન્ટ પહેલેથી જ અસ્તિત્વમાં છે",
        "Folder_already_exists": "ફોલ્ડર પહેલેથી જ અસ્તિત્વમાં છે",
        "Sprint updated successfully": "સ્પ્રિન્ટ સફળતાપૂર્વક અપડેટ થયો",
        "Project_milestone_status_updated_successfully": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ સફળતાપૂર્વક અપડેટ થઈ.",
        "Invalid_email": "તમારો ઈમેલ અમાન્ય છે. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો",
        "Invalid_password": "તમારો પાસવર્ડ અમાન્ય છે. કૃપા કરીને તપાસો અને ફરી પ્રયાસ કરો",
        "Too_many_request": "ઘણી બધી વિનંતીઓ. કૃપા કરીને પછીથી ફરી પ્રયાસ કરો",
        "Password_reset_link ": "પાસવર્ડ સમાપ્તિ ઇમેલ સફળતાપૂર્વક મોકલવામાં આવ્યું! કૃપા કરીને તમારું ઇનબોક્સ તપાસો અને તમારું પાસવર્ડ રીસેટ કરવા આગળ વધો.",
        "Project_milestone_status_added_successfully": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ સફળતાપૂર્વક ઉમેરવામાં આવી.",
        "Please_select_start_end_date": "કૃપા કરીને પ્રારંભ અને અંતિમ તારીખ બંને પસંદ કરો",
        "Invitation_canceled": "આમંત્રણ રદ થયું: તમે આ લિંકનો ઉપયોગ აღარ કરી શકો",
        "Ai_limit_reached": "તમારી દૈનિક મર્યાદા પહોંચ્યો છે.",
        "You_have_reached_the_maximum_limit_of_guest_users": "તમારી યોજના અપગ્રેડ કરો. તમે મહેમાન વપરાશકર્તાઓની મહત્તમ મર્યાદા પર પહોંચી ગયા છો.",
        "Upgrade_for_import": "આયાત કાર્યક્ષમતા ઍક્સેસ કરવા માટે તમારો પ્લાન અપગ્રેડ કરો.",
        "Upgrade_for_export": "નિકાસ કાર્યક્ષમતા ઍક્સેસ કરવા માટે તમારો પ્લાન અપગ્રેડ કરો.",
        "import_task_success": "તમારા કાર્ય સફળતાપૂર્વક આયાત કરવામાં આવ્યા છે.",
        "export_task_success": "કાર્યો સફળતાપૂર્વક નિકાસ કર્યા.",
        "export_task_error": "નિકાસ માટે કોઈ કાર્ય નથી.",
        "invalid_file_error": "અમાન્ય ફાઇલ પ્રકાર. કૃપા કરીને .csv ફાઇલ અપલોડ કરો.",
        "free_company_limit_reached": "તમે મફત કંપનીઓ બનાવવા માટેની મહત્તમ મર્યાદા પહોંચી ગયા છો.",
        "Import_users_successfully": "વપરાશકર્તાઓ સફળતાપૂર્વક આયાત થયા છે.",
        "date_range": "કૃપા કરીને લાગુ કરવા પહેલાં તારીખ શ્રેણી પસંદ કરો.",
        "Task_total_estimate_update_succesfull": "કાર્યનું કુલ અંદાજ સફળતાપૂર્વક અપડેટ થયું"
    },
    "SecurityAndPermission": {
        "project": "પ્રોજેક્ટ",
        "project_list": "પ્રોજેક્ટ યાદી",
        "project_create": "પ્રોજેક્ટ બનાવો",
        "project_name_edit": "પ્રોજેક્ટ નામ સંપાદિત કરો",
        "project_sprint_create": "પ્રોજેક્ટ સ્પ્રિન્ટ બનાવો",
        "project_folder_create": "પ્રોજેક્ટ ફોલ્ડર બનાવો",
        "project_folder_name_edit": "પ્રોજેક્ટ ફોલ્ડર નામ સંપાદિત કરો",
        "project_sprint_name_edit": "પ્રોજેક્ટ સ્પ્રિન્ટ નામ સંપાદિત કરો",
        "project_details": "પ્રોજેક્ટ વિગતો",
        "project_status_change": "પ્રોજેક્ટ સ્થિતિ બદલો",
        "project_assignee": "પ્રોજેક્ટ સોંપનાર",
        "project_category": "પ્રોજેક્ટ કેટેગરી",
        "project_source": "પ્રોજેક્ટ સ્રોત",
        "project_type": "પ્રોજેક્ટ પ્રકાર",
        "project_currency": "પ્રોજેક્ટ કરન્સી",
        "project_amount": "પ્રોજેક્ટ રકમ",
        "project_start_date": "પ્રોજેક્ટ પ્રારંભ તારીખ",
        "project_end_date": "પ્રોજેક્ટ અંતિમ તારીખ",
        "project_due_date": "પ્રોજેક્ટ નિયત તારીખ",
        "project_close": "પ્રોજેક્ટ બંધ",
        "project_description": "પ્રોજેક્ટ વર્ણન",
        "project_checklist": "પ્રોજેક્ટ ચેકલિસ્ટ",
        "project_checklist_assign_remove": "પ્રોજેક્ટ ચેકલિસ્ટ સોંપો/દૂર કરો",
        "project_attachments": "પ્રોજેક્ટ જોડાણો",
        "project_milestone": "પ્રોજેક્ટ માઇલસ્ટોન",
        "task": "કાર્ય",
        "task_list": "કાર્ય યાદી",
        "task_create": "કાર્ય બનાવો",
        "sub_task_create": "ઉપકાર્ય બનાવો",
        "task_name_edit": "કાર્ય નામ સંપાદિત કરો",
        "task_status": "કાર્ય સ્થિતિ",
        "task_assignee": "કાર્ય સોંપનાર",
        "task_priority": "કાર્ય પ્રાથમિકતા",
        "task_due_date": "કાર્ય નિયત તારીખ",
        "task_estimated_hours": "કાર્ય અંદાજિત કલાક",
        "task_description": "કાર્ય વર્ણન",
        "task_checklist": "કાર્ય ચેકલિસ્ટ",
        "task_checklist_assign_remove": "કાર્ય ચેકલિસ્ટ સોંપો/દૂર કરો",
        "task_attachments": "કાર્ય જોડાણો",
        "show_tasks": "કાર્યો બતાવો",
        "task_custom_field": "કસ્ટમ ફીલ્ડ",
        "settings": "કંપની સેટિંગ્સ",
        "settings_edit_company": "કંપની સંપાદિત કરો",
        "settings_task_priority": "કાર્ય પ્રાથમિકતા",
        "settings_file_extensions": "ફાઇલ એક્સટેન્શન",
        "settings_project_milestone_status": "પ્રોજેક્ટ માઇલસ્ટોન સ્થિતિ",
        "settings_invite_member": "સભ્યને આમંત્રિત કરો",
        "settings_member_list": "સભ્ય યાદી",
        "settings_create_team": "ટીમ બનાવો",
        "settings_team_list": "ટીમ યાદી",
        "settings_project_list": "પ્રોજેક્ટ યાદી",
        "settings_security_permissions": "સુરક્ષા અને પરવાનગીઓ",
        "settings_role_management": "ભૂમિકા વ્યવસ્થાપન",
        "settings_designation": "હોદ્દો",
        "milestone_weekly_range": "માઇલસ્ટોન સાપ્તાહિક શ્રેણી",
        "settings_custom_field": "કસ્ટમ ફીલ્ડ",
        "sheet_settings": "શીટ સેટિંગ્સ",
        "user_timesheet": "વપરાશકર્તા સમય પત્રક",
        "project_timesheet": "પ્રોજેક્ટ સમય પત્રક",
        "workload_timesheet": "કામનો ભાર સમય પત્રક",
        "milestone_report": "માઇલસ્ટોન અહેવાલ",
        "artificial_intelligence": "કૃત્રિમ બુદ્ધિ",
        "per_user_generate_limit": "પ્રતિ વપરાશકર્તા ટોકન મર્યાદા",
        "project_custom_field": "કસ્ટમ ફીલ્ડ",
        "public_projects": "જાહેર પ્રોજેક્ટ યાદી",
        "tracker_timesheet": "ટ્રેકર સમય પત્રક",
        "view_list": "યાદી જુઓ",
        "chat": "ચેટ",
        "project_delete": "પ્રોજેક્ટ કાઢી નાખો",
        "folder_archive": "ફોલ્ડર આર્કાઇવ",
        "folder_delete": "ફોલ્ડર કાઢી નાખો",
        "folder_restore": "ફોલ્ડર પુનઃસ્થાપિત કરો",
        "sprint_type_change": "સ્પ્રિન્ટ પ્રકારમાં ફેરફાર",
        "sprint_restore": "સ્પ્રિન્ટ પુનઃસ્થાપિત કરો",
        "sprint_delete": "સ્પ્રિન્ટ કાઢી નાખો",
        "sprint_archive": "સ્પ્રિન્ટ આર્કાઇવ કરો",
        "chat_channel": "ચેટ ચેનલ બનાવો",
        "chat_category": "ચેટ કેટેગરી બનાવો",
        "one_to_one_chat": "એકથી એક ચેટ",
        "task_tag": "ટાસ્ક ટૅગ",
        "task_start_date": "ટાસ્ક શરૂ કરવાની તારીખ",
        "task_activity_log": "ટાસ્ક પ્રવૃત્તિ લોગ",
        "task_convert_to_list": "ટાસ્કને લિસ્ટમાં ફેરવો",
        "task_convert_to_subtask": "ટાસ્કને સબટાસ્કમાં ફેરવો",
        "task_duplicate": "ટાસ્ક ડુપ્લિકેટ",
        "task_merge": "ટાસ્ક મર્જ",
        "task_move": "ટાસ્ક ખસેડો",
        "task_archive": "ટાસ્ક આર્કાઇવ કરો",
        "task_delete": "ટાસ્ક કાઢી નાખો",
        "task_comment": "ટાસ્ક ટિપ્પણી",
        "task_details": "ટાસ્ક વિગતો",
        "queue_list": "કતાર યાદી",
        "advance_search": "આગળ શોધ",
        "list_view_column": "યાદી દૃશ્ય સ્તંભ",
        "task_type": "કાર્ય પ્રકાર",
        "import_tasks": "કાર્ય આયાત કરો",
        "export_tasks": "કાર્ય નિકાસ કરો",
        "convert_to_task": "કાર્યમાં રૂપાંતર કરો"
    },
    "general": {
        "Continue": "ચાલુ રાખો",
        "New_Status": "નવી સ્થિતિ",
        "Old_Status": "જૂની સ્થિતિ",
        "Old_Task_Type": "જૂનો કાર્ય પ્રકાર",
        "New_Task_Type": "નવો કાર્ય પ્રકાર",
        "New_Task_Assignee": "નવો કાર્ય સોંપનાર",
        "Old_Task_Assignee": "જૂનો કાર્ય સોંપનાર",
        "New_Task_Watchers": "નવા કાર્ય વોચર્સ",
        "Old_Task_Watchers": "જૂના કાર્ય વોચર્સ",
        "Select_Status": "સ્થિતિ પસંદ કરો",
        "Select_Task_Type": "કાર્ય પ્રકાર પસંદ કરો",
        "No_Assignee": "કોઈ સોંપનાર નથી",
        "No_Watchers": "કોઈ વોચર્સ નથી",
        "Different_Statuses": "વિભિન્ન સ્થિતિઓ",
        "Please_Select_Status": "કૃપા કરીને સ્થિતિ પસંદ કરો",
        "Tomorrow": "આવતીકાલે",
        "Yesterday": "ગઈકાલે",
        "Project": "પ્રોજેક્ટ",
        "Team": "ટીમ",
        "User": "વપરાશકર્તા",
        "Copy_Assignees": "સોંપનાર નકલ કરો",
        "Copy_Watchers": "વોચર્સ નકલ કરો",
        "apply": "લાગુ કરો",
        "current_month": "વર્તમાન મહિનો",
        "current_week": "વર્તમાન અઠવાડિયું",
        "keyboard": "કિબોર્ડ",
        "mouse": "માઉસ",
        "Create": "બનાવો",
        "scroll_to_bottom": "તળિયે સ્ક્રોલ કરો",
        "unassigned": "અસાઇનમેન્ટ નથી",
        "entries": "પ્રવેશો",
        "showing": "બતાવી રહ્યા છે",
        "page_not_found": "અફસોસ, પાનું મળ્યું નથી",
        "page_not_found_description": "અમે અસુવિધા માટે ખૂબ જ દુઃખી છીએ. એવું લાગે છે કે તમે તે પૃષ્ઠને ઍક્સેસ કરવાનો પ્રયાસ કરી રહ્યા છો જે કાઢી નાખવામાં આવ્યું છે અથવા ક્યારેય અસ્તિત્વમાં નહોતું.",
        "note": "નોંધ",
        "settings_change_no_effect": "નીચેના સેટિંગ્સનો ફેરફાર વર્તમાન ફીલ્ડ મૂલ્યોને અસર કરશે નહીં જો ખાલી ન હોય",
        "advanced": "અદ્યતન",
        "general": "સામાન્ય",
        "limits": "મર્યાદાઓ",
        "message_deleted": "સંદેશા કાઢી નાખવામાં આવ્યો",
        "company_individual": "કંપની/વ્યક્તિનું નામ",
        "enter_company_individual": "કંપની/વ્યક્તિનું નામ દાખલ કરો"
    },
    "monthName": {
        "jan": "જાન્યુઆરી",
        "feb": "ફેબ્રુઆરી",
        "mar": "માર્ચ",
        "apr": "એપ્રિલ",
        "may": "મે",
        "jun": "જૂન",
        "jul": "જુલાઈ",
        "aug": "ઑગસ્ટ",
        "sep": "સપ્ટેમ્બર",
        "oct": "ઑક્ટોબર",
        "nov": "નવેમ્બર",
        "dec": "ડિસેમ્બર"
    },
    "timeLog": {
        "start_time_field_required": "પ્રારંભ સમય ફીલ્ડ જરૂરી છે",
        "end_time_field_required": "અંત સમય ફીલ્ડ જરૂરી છે",
        "select_valid_time_duration": "કૃપા કરીને માન્ય સમય અવધિ પસંદ કરો"
    },
    "weekName": {
        "sun": "રવિ",
        "mon": "સોમ",
        "tue": "મંગળ",
        "wed": "બુધ",
        "thu": "ગુરુ",
        "fri": "શુક્ર",
        "sat": "શનિ",
        "fridays": "શુક્રવાર",
        "mondays": "સોમવાર",
        "saturdays": "શનિવાર",
        "sundays": "રવિવાર",
        "thursdays": "ગુરુવાર",
        "tuesdays": "મંગળવાર",
        "wednesdays": "બુધવાર"
    },
    "tooltipText": {
        "enable_app_manage_priority": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કાર્યોમાં પ્રાથમિકતા મેનેજ કરી શકશો",
        "enable_app_manage_multiple_assignee": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કાર્યોમાં એકથી વધુ સોંપનાર મેનેજ કરી શકશો",
        "enable_app_manage_time_estimates": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કાર્યોમાં સમય અંદાજ મેનેજ કરી શકશો",
        "enable_app_manage_tags": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કાર્યોમાં ટૅગ્સ મેનેજ કરી શકશો",
        "enable_app_use_milestones": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે માઇલસ્ટોનનો ઉપયોગ કરી શકશો",
        "enable_app_use_ai_operations": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે AI ઓપરેશન્સનો ઉપયોગ કરી શકશો",
        "enable_app_manage_time_log": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કાર્યોમાં સમય લોગ મેનેજ કરી શકશો",
        "enable_app_manage_custom_fields": "આ એપને સક્રિય કરીને તમે આ પ્રોજેક્ટ માટે કસ્ટમ ફીલ્ડ્સ મેનેજ કરી શકશો"
    },
    "Company": {
        "fill_company_details": "તમારી કંપનીની વિગતો ભરો",
        "set_up_company": "તમારી કંપની સેટ કરો",
        "creating_company": "કંપની બનાવી રહ્યા છે",
        "company_created": "તમારી કંપની બનાવવામાં આવી છે. અમે પ્રારંભિક પગલાં સેટ કરી છે. કૃપા કરીને થોડી વાર રાહ જુઓ.",
        "good_to_go": "જવા માટે સારા",
        "select_default_country": "ડિફોલ્ટ દેશ પસંદ કરો",
        "freelimitreachedstart": "તમે પહેલેથી જ એક મફત કંપની બનાવી છે. નવી કંપની બનાવવા માટે, તમને પ્રથમ ચૂકવેલ યોજના પર અપગ્રેડ કરવાની જરૂર છે",
        "freelimitreachedend": "એકવાર અપગ્રેડ કર્યા પછી, તમે બીજી મફત કંપની ઉમેરવા માટે તૈયાર હશો."
    },
    "Subscription": {
        "subscription_cancelled": "તમે વર્તમાન સબ્સ્ક્રિપ્શન અવધિના અંતે તમારું સબ્સ્ક્રિપ્શન રદ કર્યું છે",
        "discard_changes": "તમારા સબ્સ્ક્રિપ્શન માટે વપરાશકર્તા આ ફેરફારોને રદ કરશે, અને તમારું વર્તમાન સબ્સ્ક્રિપ્શન આગામી બિલિંગ ચક્રથી ચાલુ રહેશે.",
        "confirm_terminate_schedule": "શું તમે ખરેખર શેડ્યૂલ સબ્સ્ક્રિપ્શન રદ કરવા માંગો છો?",
        "confirm_add_user": "શું તમે ખરેખર તમારા સબ્સ્ક્રિપ્શનમાં વપરાશકર્તા ઉમેરવા માંગો છો?",
        "confirm_remove_user": "શું તમે ખરેખર સબ્સ્ક્રિપ્શનમાંથી વપરાશકર્તાને દૂર કરવા માંગો છો?",
        "next_invoice_amount": "તમારું આગામી ભરતિયું હશે",
        "credits_applied": "ક્રેડિટ્સ લાગુ",
        "current_billing_for_upgrade": "અપગ્રેડ માટે વર્તમાન બિલિંગ",
        "plan_upgrade_success": "અભિનંદન! તમારું પ્લાન અપગ્રેડ સફળતાપૂર્વક શેડ્યૂલ કરવામાં આવ્યું છે, અને સુધારાઓ વર્તમાન અવધિના અંતે અસર કરશે. તમારા સબ્સ્ક્રિપ્શનના આગામી તબક્કામાં અપગ્રેડ કરેલી સુવિધાઓ અને લાભોનો આનંદ માણવા માટે તૈયાર થાઓ.",
        "subscription_upgrade_from": "તમારું સબ્સ્ક્રિપ્શન અપગ્રેડ થશે",
        "total_payable_amount": "કુલ ચૂકવવાપાત્ર રકમ",
        "update_subscription": "સબ્સ્ક્રિપ્શન અપડેટ કરો",
        "updated_subscription_price": "અપડેટ કરેલ સબ્સ્ક્રિપ્શન કિંમત",
        "upgrade_subscription": "સબ્સ્ક્રિપ્શન અપગ્રેડ કરો",
        "confirm_subscription_change": "શું તમે ખરેખર તમારું સબ્સ્ક્રિપ્શન બદલવા માંગો છો",
        "monthly": "મહિનો",
        "yearly": "વર્ષ",
        "remove_scheduled_cancellation_confirmation": "'હા' ક્લિક કરવાથી શેડ્યૂલ રદ થઈ જશે અને તમારો બિલિંગ ચક્ર ચાલુ રહેશે.",
        "scheduled_cancellation_notice": "તમારા વર્તમાન સબ્સ્ક્રિપ્શનનું શેડ્યૂલ રદ છે",
        "credit_entitlement_congratulations": "અભિનંદન! તમે ક્રેડિટ માટે પાત્ર છો",
        "credit_note_application": "તમારા વર્તમાન સબ્સ્ક્રિપ્શન માટે. આ ક્રેડિટ નોટ તમારા સબ્સ્ક્રિપ્શનને સુધારવા માટે સરળતાથી લાગુ કરવામાં આવશે, અને તે તમારા આગામી ભરતિયાંમાંથી આપમેળે કાપી લેવામાં આવશે, તમારા સબ્સ્ક્રિપ્શન પ્રવાસ માટે સતત મૂલ્ય અને બચતની ખાતરી આપશે.",
        "invoice_period_coverage": "ભરતિયું આ અવધિ માટે છે"
    },
    "Card": {
        "pay_with": "ચુકવણી કરો",
        "add_new_card": "નવું કાર્ડ ઉમેરો",
        "name_on_card": "કાર્ડ પર નામ",
        "card_number": "કાર્ડ નંબર",
        "expiry": "સમાપ્તિ",
        "cvc": "CVC"
    },
    "alertBox": {
        "updateBillingAddress": "તમારે પ્રથમ બિલિંગ સરનામું અપડેટ કરવું પડશે",
        "valid_csv_title": "કોઈ ફાઈલ અપલોડ કરાઈ નથી",
        "valid_csv_text": "કૃપા કરીને આગળ વધવા માટે માન્ય .csv ફાઇલ અપલોડ કરો.",
        "ok": "ઠીક છે",
        "cancel": "રદ કરો",
        "go_back_title": "પાછા જશો?",
        "go_back_text": "શું તમે ખરેખર અગાઉના પગથિયે પાછા જવા માંગો છો?",
        "close_modal_title": "મોડલ બંધ કરશો?",
        "close_modal_text": "શું તમે ખરેખર મોડલ બંધ કરવા માંગો છો? આ પગથિયા સુધીની તમારી બધી માહિતી ગુમ થઈ જશે.",
        "no": "ના",
        "yes": "હા",
        "confirm": "પુષ્ટિ કરો",
        "improper_header_selection_title": "અયોગ્ય પસંદગી",
        "improper_header_selection_text": "પસંદ કરેલ પંક્તિમાં નોન-સ્ટ્રિંગ મૂલ્યો છે. કૃપા કરીને અલગ પંક્તિ પસંદ કરો.",
        "missing_fields_title": "જરૂરી ક્ષેત્રો ગુમ છે",
        "missing_fields_text": "આગળ વધતા પહેલા નીચેના જરૂરી ક્ષેત્રો નકશો અને પુષ્ટિ કરવા પડશે.",
        "warning_title": "ચેતવણી",
        "warning_text": "જ્યારે તમે આગળ વધશો, ત્યારે 'Task Priority' અને 'Status' માં ખાલી મૂલ્યો અનુક્રમમાં 'Medium' અને 'To Do' તરીકે લઈ લેવાશે.",
        "incomplete_mapping_title": "અપૂર્ણ મૅપિંગ",
        "incomplete_mapping_text": "આગળ વધવા માટે કૃપા કરીને બધી અનન્ય કિંમતોને ઓછામાં ઓછી એક Hyphen OI Pro કિંમત સાથે નકશો કરો.",
        "invalid_tasks_error": "કોઈ માન્ય કાર્યો મળ્યા નથી. કૃપા કરીને ખાતરી કરો કે જરૂરી ફીલ્ડ ખાલી નથી."
    },
    "importTaskButton": {
        "import_title": "કાર્ય આયાત કરો",
        "import_button": "CSV માંથી ટાસ્ક ઇમ્પોર્ટ કરો",
        "back_button": "પાછા જાઓ",
        "next_button": "આગળ વધો",
        "export_button": "CSV તરીકે નિકાસ કરો",
        "import_processing": "તમારા કાર્ય આયાત કરવામાં આવી રહ્યા છે."
    },
    "importCsvAndSetHeader": {
        "download": "ડાઉનલોડ",
        "demo_csv": "ડેમો CSV",
        "down_demo_text": "ફાઈલ અને તમારી આયાત ફાઈલની સરખામણી કરો જેથી તમે આયાત માટે પરફેક્ટ ફાઇલ હોય તે સુનિશ્ચિત કરી શકો.",
        "upload_button": "તમારું CSV ફાઇલ અહીં અપલોડ કરો",
        "upload_instructions": "તમે કોઈપણ .csv ફાઇલ અપલોડ કરી શકો છો જેમાં કોઇ પણ કૉલમ હોય, જયાં દર પંક્તિએ એક રેકોર્ડ હોય. આગામી પગથિયે તમને તમારા સ્પ્રેડશીટ કૉલમ્સને યોગ્ય ડેટા પોઈન્ટ્સ સાથે નકશો કરવાની મંજૂરી મળશે. તમે અંતિમ અહેવાલ પહેલાં કોઇ પણ ખોટા ડેટાને સાફ અથવા દૂર પણ કરી શકશો.",
        "header_row_question": "શું પસંદ કરેલ પંક્તિમાં કૉલમ હેડર્સ છે?",
        "select_another_button": "બીજી પંક્તિ પસંદ કરો",
        "confirm_row_btt": "પુષ્ટિ કરો"
    },
    "headerMapping": {
        "title": "હેડર મૅપિંગ",
        "mapping_instructions": "ચાલો, તમારા હેડર્સને Hyphen OI Pro હેડર્સ સાથે નકશો કરીએ",
        "pending_count": "બાકી રહેલા ક્ષેત્રો:",
        "confirmed_count": "પુષ્ટિ થયેલા ક્ષેત્રો:",
        "ignored_count": "ઉપેક્ષિત ક્ષેત્રો:",
        "custom_count": "કસ્ટમ ક્ષેત્રો:",
        "confirmed_text": "પુષ્ટિ કરેલ",
        "ignored_text": "ઉપેક્ષિત",
        "edit_button": "સંપાદન કરો",
        "no_match_title": "કોઇ મેળ નહીં",
        "no_match": "કોઇ મેળ મળ્યો નથી",
        "no_match_description": "આ ક્ષેત્ર અમારા હેડર્સ સાથે મેળ ખાતું નથી. કૃપા કરીને તેને ઉપેક્ષિત કરો અથવા કસ્ટમ ફીલ્ડ તરીકે સામેલ કરો.",
        "custom_field_button": "કસ્ટમ ફીલ્ડ તરીકે સામેલ કરો",
        "ignore_field_button": "આ ક્ષેત્ર અવગણો",
        "matched_to_field": "મેચ થયેલ ક્ષેત્ર:",
        "duplication_warning": "આ ક્ષેત્ર નકલ છે અને તેને પુષ્ટિ કરી શકાય નથી. કૃપા કરીને બીજું ક્ષેત્ર પસંદ કરો.",
        "confirm_map_button": "મૅપિંગની પુષ્ટિ કરો"
    },
    "reviewMaping": {
        "title": "મહેરબાની કરીને અમારી ફીલ્ડ્સમાં નકશાયેલ તમારું ડેટા સમીક્ષા કરો. (તમે અહીં ડેટા મૂલ્યો પણ સંપાદિત કરી શકો છો.)",
        "warning": "તમારી પાસે એક અથવા વધુ જરૂરી ફીલ્ડ્સ ખૂટે છે અથવા અમાન્ય મૂલ્યો છે. કૃપા કરીને તેને સમીક્ષા કરો, નહિંતર તે પંક્તિઓ આયાત કરવામાં આવશે નહીં."
    },
    "valueMapping": {
        "user_mapping_title": "વપરાશકર્તા મૅપિંગ",
        "user_mapping_instruction": "સોંપણીઓ, નેતાઓ અને ટાસ્ક પ્રવૃત્તિઓને જાળવી રાખવા માટે Hyphen OI Pro વપરાશકર્તાઓ સાથે વપરાશકર્તાઓ નકશો કરો. જો તમે વપરાશકર્તાઓને નકશો નહીં કરો, તો ડેટા હજુ પણ આયાત નહીં થાય કારણ કે તે Hyphen OI Pro વપરાશકર્તાઓ સાથે સમકક્ષ થઈ શકશે નહીં.",
        "user_dropdown_text": "વપરાશકર્તા પસંદ કરો",
        "status_mapping_title": "સ્થિતિ મૅપિંગ",
        "status_mapping_instruction": "ભવિષ્યની વર્કફ્લોને સુસંગત રાખવા માટે, કૃપા કરીને તમારી સ્થિતિ મૂલ્યોને Hyphen OI Pro માં રહેલી વર્તમાન મૂલ્યો સાથે નકશો કરો. આ આગામી ગડબડ ટાળવામાં મદદ કરશે.",
        "status_dropdown_text": "સ્થિતિ પસંદ કરો",
        "priority_mapping_title": "પ્રાથમિકતા મૅપિંગ",
        "priority_mapping_instruction": "ભવિષ્યની વર્કફ્લોને સુસંગત રાખવા માટે, કૃપા કરીને તમારી પ્રાથમિકતા મૂલ્યોને Hyphen OI Pro માં રહેલી વર્તમાન મૂલ્યો સાથે નકશો કરો. આ ગડબડ ટાળવામાં મદદ કરશે.",
        "priority_dropdown_text": "પ્રાથમિકતા પસંદ કરો",
        "custom_field_mapping_title": "કસ્ટમ ફીલ્ડ મૅપિંગ",
        "custom_field_mapping_instruction": "સૂસંગતતા સુનિશ્ચિત કરવા માટે, કૃપા કરીને તમારી કસ્ટમ ફીલ્ડ પ્રકારોને Hyphen OI Pro માં રહેલા પ્રકારો સાથે નકશો કરો. આ ગડબડ ટાળવામાં મદદ કરશે.",
        "custom_delimiters_quest": "ℹ️ શું તમારી કસ્ટમ ફીલ્ડ મૂલ્યોને અલગ પાડવા માટે કોઈ ડિલિમિટર્સ છે?"
    },
    "importMappingKeywords": {
        "task_id_description": "વિશિષ્ટ કાર્યનો ID.",
        "task_name_description": "કાર્યનું નામ, સામાન્ય રીતે ટૂંકું સારાંશ.",
        "task_description_description": "કાર્ય વિશેની વિગતવાર માહિતી.",
        "task_assignee_description": "કાર્ય માટે નિયુક્ત વ્યક્તિનો ઈમેલ સરનામું.",
        "task_parentId_description": "આ કાર્ય સંબંધિત માતૃ કાર્યનો ID.",
        "task_leaderId_description": "આ કાર્યનું નેતૃત્વ કરતી વ્યક્તિનો વપરાશકર્તા ID.",
        "task_priority_description": "કાર્યને આપેલ મહત્વનો સ્તર.",
        "task_status_description": "કાર્યની હાલની સ્થિતિ અથવા પ્રગતિ.",
        "task_start_date_description": "કાર્ય શરૂ થવાની તારીખ.",
        "task_due_date_description": "કાર્ય પૂર્ણ કરવાની તારીખ."
    },
    "Affiliate": {
        "refer_earn": "ભલામણ કરો અને કમાવો",
        "unlimited": "અસીમિત",
        "invite_start_earning_cash_rewards": "તમારા મિત્રો ને આમંત્રિત કરો અને નકદી ઇનામ કમાવવાનું શરૂ કરો.",
        "your_referral_code": "તમારું રેફરલ કોડ",
        "invite_spend_message": "તમારા મિત્રના દરેક ખર્ચ પર, તમને તે રકમમાંના {percentage}% નું ઇનામ મળશે.",
        "inviteText": "આ લિંક શેર કરીને મિત્રોને આમંત્રિત કરો",
        "copy": "કૉપી",
        "refferal_code_label": "રેફરલ કોડ",
        "refferal_code_placeholder": "રેફરલ કોડ દાખલ કરો",
        "invalid_refferal_model_title": "તમારો રેફરલ કોડ અમાન્ય છે",
        "invalid_refferal_model_confirm_text": "હા, તે બનાવો!",
        "invalid_refferal_model_text": "શું તમે ચોક્કસ છો કે તમે કંપની બનાવવા માંગો છો?",
        "refferal_code_error": "રેફરલ કોડ માન્ય નથી"
    },
    "dashboardCard": {
        "tasks_by_assignee_bar_chart_description": "તમારા કુલ કામો માટે જવાબદાર દ્વારા એક બાર ગ્રાફ દર્શાવો",
        "tasks_by_assignee_bar_chart_title": "જવાબદાર દ્વારા કામો",
        "task_list_description": "કોઈપણ સ્થાનથી કામોની સૂચિ દૃશ્ય બનાવો",
        "tasks_list_title": "કામોની સૂચિ",
        "tasks_by_assignee_stack_bar_chart_description": "તમારા કુલ કામોની જવાબદાર દ્વારા સ્ટેક બાર ગ્રાફ દર્શાવો",
        "tasks_by_assignee_stack_bar_chart_title": "જવાબદાર દ્વારા કામો",
        "workload_by_status_stack_bar_chart_description": "તમારા વિવિધ સ્થાનોમાં સ્થિતિઓની વિભાજન દર્શાવો",
        "workload_by_status_stack_bar_chart_title": "સ્થિતિ અનુસાર કામનો બોજ",
        "tasks_by_assignee_pie_chart_description": "તમારા કુલ કામોની જવાબદાર દ્વારા પાઈ ચાર્ટ દર્શાવો",
        "tasks_by_assignee_pie_chart_title": "જવાબદાર દ્વારા કામો",
        "workload_by_status_pie_chart_description": "તમારા વિવિધ સ્થાનોમાં સ્થિતિઓના ઉપયોગનો પાઈ ચાર્ટ દર્શાવો",
        "workload_by_status_pie_chart_title": "સ્થિતિ અનુસાર કામનો બોજ",
        "workload_by_status_bar_chart_description": "તમારા વિવિધ સ્થાનોમાં સ્થિતિઓના ઉપયોગનો બાર ચાર્ટ દર્શાવો",
        "workload_by_status_bar_chart_title": "સ્થિતિ અનુસાર કામનો બોજ",
        "queue_list_title": "પ્રતીક્ષા યાદી",
        "queue_list_description": "તમારા કામોની સૂચિ અને તેમની સ્થિતિઓ જુઓ.",
        "card_name": "કાર્ડનું નામ",
        "location": "પ્રોજેક્ટ",
        "group_by": "આધારે જૂથબદ્ધ કરો",
        "show_assignees": "જવાબદાર દર્શાવો",
        "include_subtasks": "ઉપકામો શામેલ કરો",
        "display_labels_as_percent": "લેબલ ટકાવારી રૂપે દર્શાવો",
        "show_legend": "લીજન્ડ દર્શાવો",
        "show_Data_Labels": "માહિતી લેબલ્સ દર્શાવો",
        "select": "પસંદ કરો",
        "add_card": "કાર્ડ ઉમેરો",
        "back": "પાછળ",
        "error_assignees": "જવાબદાર દર્શાવવાનું ક્ષેત્ર જરૂરી છે",
        "error_location": "સ્થાનનું ક્ષેત્ર જરૂરી છે",
        "empty_layout_container": "તમારું ડેશબોર્ડ ખાલી છે. પ્રારંભ કરવા માટે 'કાર્ડ ઉમેરો' ક્લિક કરો.",
        "status": "સ્થિતિ",
        "edit_card": "કાર્ડ સંપાદિત કરો",
        "calendar_card_title": "કૅલેન્ડર",
        "calendar_card_description": "આ કાર્ય માટેની કૅલેન્ડર દૃશ્ય છે",
        "measure": "માપ",
        "calculation": "ગણતરી",
        "total_urgent_tasks": "કુલ તાત્કાલિક કાર્ય",
        "total_urgent_tasks_description": "સ્થાન દ્વારા કુલ તાત્કાલિક કાર્યો બતાવો",
        "time_tracker": "સમય ટ્રેકર",
        "time_estimate": "સમય અંદાજ",
        "range": "શ્રેણી",
        "max": "મહત્તમ",
        "min": "ન્યૂનતમ",
        "median": "મધ્યાન",
        "average": "સરેરાશ",
        "sum": "કુલ",
        "workload_estination_title": "સમય અહેવાલ",
        "workload_estination_description": "કામો જુઓ જેમાં સમય ટ્રૅક અને અંદાજિત છે.",
        "workload_only_estination_title": "અંદાજિત સમય",
        "workload_only_estination_description": "અંદાજિત સમય જુઓ.",
        "time_only_estination_title": "લૉગ થયેલ સમય",
        "time_only_estination_description": "લૉગ થયેલ સમય જુઓ.",
        "today": "આજે",
        "yesterday": "ગઇકાલે",
        "this_week": "આ અઠવાડિયું",
        "last_week": "ગત અઠવાડિયું",
        "this_month": "આ મહિનો",
        "last_month": "ગત મહિનો",
        "this_year": "આ વર્ષ",
        "last_30_days": "છેલ્લા 30 દિવસ",
        "task": "કાર્ય ગણતરી",
        "task_label": "કાર્ય લેબલ",
        "both": "બન્ને બતાવો",
        "manual_time": "ફક્ત મેન્યુઅલ સમય બતાવો",
        "track_time": "ફક્ત ટ્રેક કરેલ સમય બતાવો",
        "logtype": "સમય લૉગ્સ",
        "timerange": "સમય અવધિ",
        "priority": "પ્રાથમિકતા",
        "due_date": "અંતિમ તારીખ",
        "none": "કંઇ નહીં",
        "total_time_track_description": "કુલ સમય ટ્રેક બતાવો",
        "total_time_track_tasks": "કુલ સમય ટ્રેક",
        "total_tasks_count_description": "કુલ કાર્યની સંખ્યા બતાવો",
        "total_tasks_count": "કુલ કાર્ય સંખ્યા",
        "assignees": "કાર્ય સોંપવામાં આવેલ",
        "feature": "વિશેષતા",
        "workload": "કાર્યભાર",
        "time_tracking": "સમયની નોંધ",
        "task_card": "કાર્યો",
        "Today": "આજે",
        "Yesterday": "ગઈકાલે",
        "Tomorrow": "આવતીકાલે",
        "This_week": "આ સપ્તાહ",
        "Next_week": "આવતા અઠવાડિયે",
        "Next_seven_days": "આગામી ૭ દિવસ",
        "Last_seven_days": "છેલ્લા ૭ દિવસ",
        "Last_month": "ગયા મહિને",
        "This_month": "આ મહિનો",
        "Next_month": "આવતા મહિને",
        "Date_range": "તારીખ શ્રેણી",
        "me_mode": "હું",
        "data": "ડેટા",
        "display": "દર્શાવો",
        "fields": "ફીલ્ડ્સ"
    },
    "designationMapping": {
        "title": "હોદ્દા નિરૂપણ",
        "description": "મહેરબાની કરીને તમારા CSV માંના હોદ્દાને Hyphen OI Pro માં હાજર હોદ્દા સાથે નકશો બનાવો."
    },
    "roleMapping": {
        "title": "ભૂમિકા નિરૂપણ",
        "description": "મહેરબાની કરીને તમારા CSV માંની ભૂમિકાને Hyphen OI Pro માં હાજર ભૂમિકાઓ સાથે નકશો બનાવો."
    },
    "importUserKeywords": {
        "user_email_description": "વપરાશકર્તાનું ઈમેલ આઈડી",
        "user_role_description": "સંસ્થામાં વપરાશકર્તાને આપવામાં આવેલ ભૂમિકા અથવા નોકરીનું શીર્ષક.",
        "user_designation_description": "કંપનીમાં કર્મચારીની સત્તાવાર હોદ્દા અથવા નોકરીનું શીર્ષક."
    },
    "userSelection": {
        "title": "વપરાશકર્તા પસંદગી",
        "user_limit_error": "વપરાશકર્તાની મહત્તમ મર્યાદા પહોંચી ગઈ છે. વધુ વપરાશકર્તાઓ આયાત કરવા માટે તમારું પ્લાન અપગ્રેડ કરો.",
        "description": "તમારા આયાત કરવા માટે તમામ વપરાશકર્તાઓને પસંદ કરો.",
        "duplicate_email_error": "આ ઈમેલ આઈડી પહેલેથી જ Hyphen OI Pro માં હાજર છે. તમે તેને આયાત કરી શકતા નથી.",
        "invalid_email": "આ ઈમેલ આઈડી અમાન્ય છે. મહેરબાની કરીને માન્ય ઈમેલ આઈડી નો ઉપયોગ કરો.",
        "invalid_fields": "તમારા પાસે એક કે વધુ અમાન્ય ફીલ્ડ્સ છે. કૃપા કરીને હાઇલાઇટ કરેલ ફીલ્ડ્સ તપાસો.",
        "user_limit_100": "તમે એક સમયે મહત્તમ 100 વપરાશકર્તાઓ આયાત કરી શકો છો."
    },
    "importUserButton": {
        "import_user_processing": "તમારા વપરાશકર્તાઓ આયાત થઈ રહ્યા છે"
    },
    "timeForecastingReport": {
        "project_name": "પ્રોજેક્ટનું નામ",
        "project_status": "પ્રોજેક્ટની સ્થિતિ",
        "start_date": "પ્રારંભ તારીખ",
        "due_date": "નિયત તારીખ",
        "last_logged_date": "છેલ્લી લોગ થયેલી તારીખ",
        "budget": "બજેટ",
        "actual": "વાસ્તવિક",
        "forecast": "અંદાજ",
        "estimated_hours": "અંદાજિત કલાકો",
        "logged_hours": "લોગ થયેલા કલાકો",
        "remaining_hours": "બાકી કલાકો",
        "overdue_hours": "વિલંબિત કલાકો",
        "estimated_time_to_complete": "પૂર્ણ કરવાની અંદાજિત સમયાવધિ",
        "estimated_complition_date": "અંદાજિત પૂર્ણ થવાની તારીખ",
        "show_legends": "લેજેન્ડ બતાવો",
        "show_data_labels": "ડેટા લેબલ્સ બતાવો",
        "report_type": "રિપોર્ટ પ્રકાર"
    }
}